var petcoNearestLocations = (function(){


		var _sStoreId = '10151',
		_nExpirationMin = window.LOCALSTORAGE_EXPIRY_MINUTES ? window.LOCALSTORAGE_EXPIRY_MINUTES : 1440,
		_timestamp = new Date().getTime(),
		_geoLatitude = '',
		_geoLongitude = '',
		_bIsHTML5Geolocation = true,
		_bIsGoogleGeoAPI = true,
		_nHTML5GeoTimeout = 10000,
		_nXHRTimeout = 5000,
		_bIsDebuggingEnabled = false,
			_changeStoreModalClick=false,
		_sZipCode = '',
		_tempStoreData = [],
		_userData = {},
		_oStoreHours = {},
		_shipmodedetails = {},
		_oInStoreInventoryData = {},
		_nLastStoreDistance = '',
		_sKey = '',
		_sGoogleAPIUrl = '',
		_showPreferredStore = true,
		_storePassedAsParam='',
		_storeCodeParameter='store_code',
		_sGoogleStoreCodePresent = false,
		_akamaiZipCode='',
		_nLocationExpirationMin=window.locationExpirationMin ? window.locationExpirationMin : 129600,


			 NEAREST_STORES_API = 'getneareststores',


			 ZIPCODE_API = 'zipcode',

			 AKAMAI_ZIPCODE = 'akamai_zipcode',

			 LATITUDE_LONGITUDE_API = 'latlong',

			 LOCALSTORAGE_STORES_KEY = 'petcostores',

	 	 LOCALSTORAGE_LATITUDE_LONGITUDE_KEY = 'petcostores_latitude_longitude',
	 EXPIR_STORE_DATA='expiredStoreData',


			 LOCALSTORAGE_TIMEOUT_KEY = 'geolocationtimeout',


			 PETCO_STORE_LOGO = '/wcsstore/PetcoStore/img/brand-logo.png',

					 PETCO_NEXT_STORE_LOGO = '/wcsstore/PetcoStore/img/next_brand-logo.png',


			 UNLEASHED_STORE_LOGO = '/wcsstore/PetcoStore/img/logo-unleashed.gif',


					 UNLEASHED_NEXT_STORE_LOGO = '/wcsstore/PetcoStore/img/next_logo-unleashed.png',

				 MAP_PIN_ICON = '/wcsstore/PetcoStore/img/map-pin-icon.png',

	 	 ClosedStoreDetailsObj = null,
	 _store_got_Changed = false,
	IS_HTML5_CALL_COMPLETED=false;


	 function fnXHRCall(options){
		if(_bIsDebuggingEnabled){
			console.debug('Debugging:: Entering fnXHRCall()');
		}
		var oRequestInfo = options || {};

		oRequestInfo.method = options.method || 'GET';
		oRequestInfo.url = options.url || '';
		oRequestInfo.contentType = options.contentType || 'application/json';
		oRequestInfo.dataType = options.dataType || 'json';
		oRequestInfo.data = options.data || {};
		oRequestInfo.timeout = options.timeout || _nXHRTimeout;
		oRequestInfo.requestType = options.requestType || '';

				if(_bIsDebuggingEnabled){
			console.debug('Debugging:: oRequestInfo object - '+JSON.stringify(oRequestInfo));
	 		console.debug('Debugging:: Entering $.ajax()');
		}
	 	$.ajax({
	 		url : oRequestInfo.url,
	 		type : oRequestInfo.method,
	 		contentType: oRequestInfo.contentType,
	 		dataType: oRequestInfo.dataType,
	 		data: JSON.stringify(oRequestInfo.data),
	 		cache: false,
	 		timeout: oRequestInfo.timeout,
	 		success: function(data){
	 			fnSuccessHandler(data,oRequestInfo.requestType);		
	 		},
	 		error: function(error){
	 			fnErrorHandler(error,oRequestInfo.requestType);
	 		}

	 	});

	 		 	if(_bIsDebuggingEnabled){
	 		console.debug('Debugging:: Exiting fnXHRCall()');
		}
	 }


	 function fnBuildUrl(urlType){

		 		if(_bIsDebuggingEnabled){
			console.debug('Debugging:: Entering fnBuildUrl(urlType)');
			console.debug('Debugging:: urlType - '+urlType);
		}

			 	var url = '',
	 		protocol = window.location.protocol,
	 		hostname = window.location.hostname,
	 		portname = window.location.port,
	 		rootPath = '/wcs/resources/store/'+_sStoreId+'/petcostorelocator/';
	 		if($('div.previewEspot[id^="ShowInformation_ID_"]').length > 0 ){
	 			rootPath = '/wcs/previewresources/store/'+_sStoreId+'/petcostorelocator/';
	 		}

	 		 	if( portname != "" ){
	 		hostname = hostname+":"+portname;
	 	}

	 	 		if(urlType == NEAREST_STORES_API){
 			url =  _sGoogleAPIUrl +_sKey;
 		}else if(urlType == LATITUDE_LONGITUDE_API){
 			url = protocol + '//' + hostname + rootPath + 'latitude/' + _geoLatitude + '/longitude/' + _geoLongitude + '/'+ NEAREST_STORES_API;
 		}else if(urlType == ZIPCODE_API){
 			url = protocol + '//' + hostname + rootPath + 'getneareststoresbyzipcode';
 		}else if(urlType == AKAMAI_ZIPCODE){
 			url = protocol + '//' + hostname + rootPath + 'getneareststoresbyzipcode';
 		}

	 		 		if(_bIsDebuggingEnabled){
			console.debug('Debugging:: url - '+url);
			console.debug('Debugging:: Exiting fnBuildUrl(urlType)');
		}
 		if(_storePassedAsParam != ""){
 			if(url.indexOf('?') == -1){
 				url = url+"?storeCode="+_storePassedAsParam;
 			}else{
 				url = url+"&storeCode="+_storePassedAsParam;
 			}

 			 		}
	 	return url;
	 }


	 	 function fnGeoLocation(){
		 if(_bIsDebuggingEnabled){
			 console.debug('Debugging:: Entering fnGeoLocation()');
			 console.debug('Debugging:: _bIsHTML5Geolocation - ' + _bIsHTML5Geolocation);
			 console.debug('Debugging:: _bIsGoogleGeoAPI - ' + _bIsGoogleGeoAPI);
		 }
		 if(_bIsHTML5Geolocation){
			 if(_bIsDebuggingEnabled){
				 console.debug('Debugging:: navigator.geolocation - ' + navigator.geolocation);
			 }
			 if (navigator && navigator.geolocation) {
				 var optn = {
					 enableHighAccuracy : true,
					 timeout: _nHTML5GeoTimeout
				 };
		        navigator.geolocation.getCurrentPosition(fnProcessGeoResponse,fnProcessGeoError,optn);
		        jQuery(window).load(function () {
					 setTimeout(function(){
						 if(!IS_HTML5_CALL_COMPLETED){
							 var errorCode = {};
							 errorCode.code = 5;
							 fnProcessGeoError(errorCode);
							 IS_HTML5_CALL_COMPLETED=true;
						 }
					 },_nHTML5GeoTimeout);
		        });

		     }else {
		    	 if(_bIsGoogleGeoAPI){
		    		 if(_bIsDebuggingEnabled){
						 console.debug('Debugging:: HTML5 Geolocation is not used. Calling the fnGetData("neareststores").');
					 }
				    fnGetData(NEAREST_STORES_API);
		    	 }else{
		    		 if(_bIsDebuggingEnabled){
						 console.debug('Debugging:: HTML5 Geolocation is not used and Google API is disabled. Inside the logic to show the link for select a store.');
					 }
		    		 if(fnIsPDP() && fnIsBOPUSItem()){
							if($('#isBOPUSHide').length != 0){
								$('#isBOPUSHide')[0].value="yes";
							}
							 dojo.topic.publish('ChangeBasedOnLocationCallCompleted', "hide");
	    			 }
		    		 localStorage.setItem(LOCALSTORAGE_TIMEOUT_KEY, 'true');
		    	 }
		     }
		 }else{
			 if(_bIsDebuggingEnabled){
				 console.debug('Debugging:: HTML5 Geolocation switch is off. _bIsHTML5Geolocation - ' + _bIsHTML5Geolocation);
				 console.debug('Debugging:: _bIsGoogleGeoAPI - '+ _bIsGoogleGeoAPI);
			 }
			 if(_bIsGoogleGeoAPI){
				 if(_bIsDebuggingEnabled){
					 console.debug('Debugging:: HTML5 Geolocation is disabled. Google API is enabled. Calling the fnGetData("neareststores").');
				 }
			     fnGetData(NEAREST_STORES_API);
	    	 }else{
	    		 if(_bIsDebuggingEnabled){
					 console.debug('Debugging:: HTML5 Geolocation is disabled and Google API is disabled.');
				 }
	    		 if(fnIsPDP() && fnIsBOPUSItem()){
	    			 if(_bIsDebuggingEnabled){
						 console.debug('Debugging:: Hide the store locator section.');
					 }
					fnHideStoreLocatorSection();
    			 }

    			 	    		 localStorage.setItem(LOCALSTORAGE_TIMEOUT_KEY, 'true');
	    	 }
		 }

		 		 if(_bIsDebuggingEnabled){
			 console.debug('Debugging:: Exiting fnGeoLocation().');
		 }

		 	 }

		 	 function fnGeoLocationFromLatLongLocalStorage(){
		 if(_bIsDebuggingEnabled){
			 console.debug('Debugging:: Entering fnGeoLocationFromLatLongLocalStorage()');
		 }
		 var oLatLongData = JSON.parse(localStorage.getItem(LOCALSTORAGE_LATITUDE_LONGITUDE_KEY)) != null ? JSON.parse(localStorage.getItem(LOCALSTORAGE_LATITUDE_LONGITUDE_KEY)) : {};
				 if(oLatLongData != null && Object.keys(oLatLongData).length != 0){
					 _geoLatitude = oLatLongData.latitude;
					 _geoLongitude = oLatLongData.longitude;

					 					 if(_bIsDebuggingEnabled){
						 console.debug('Debugging:: latitude - ' + _geoLatitude);
						 console.debug('Debugging:: longitude - ' + _geoLongitude);
						 console.debug('Debugging:: Calling fnGetData("latlong")');
					 }
				     fnGetData(LATITUDE_LONGITUDE_API);
				 }
		 if(_bIsDebuggingEnabled){
			 console.debug('Debugging:: Exiting fnGeoLocationFromLatLongLocalStorage().');
		 }
	 }


		 	 function fnProcessGeoError(oError){
		 if(_bIsDebuggingEnabled){
			 console.debug('Debugging:: Entering fnProcessGeoError(oError).');

					 }
		 if(IS_HTML5_CALL_COMPLETED){
			 return;
		 }
		 IS_HTML5_CALL_COMPLETED=true;
		 var errorCode = oError.code,
		 	 errors = { 
				    1: 'Permission denied',
				    2: 'Position unavailable',
				    3: 'Request timeout',
				    4: 'Unknown error',
				    5: 'No input from user'
				  };
		 if(errorCode){
			 if(_bIsDebuggingEnabled){
				 console.debug('Debugging:: Error - '+ errors[errorCode]);
				 console.debug('Debugging:: _bIsGoogleGeoAPI - '+ _bIsGoogleGeoAPI);
			 }
			 if(errorCode == '5'){
				 if(_bIsDebuggingEnabled){
					 console.debug('Debugging:: User did not allow or block HTML5 location. Take value from Akamai lat long.');
				 }
				 fnGetData('AKAMAI_LATLONG');
			 }else if(_bIsGoogleGeoAPI && errorCode != '5'){
				 if(_bIsDebuggingEnabled){
					 console.debug('Debugging:: Google API is enabled. Calling the fnGetData("neareststores").');
				 }
				 fnGetData(NEAREST_STORES_API);
			 }else{
				 if(_bIsDebuggingEnabled){
					 console.debug('Debugging:: Google API is disabled. Inside the logic to show the link for select a store.');
				 }
				 if(fnIsPDP() && fnIsBOPUSItem()){
					 if(_bIsDebuggingEnabled){
						 console.debug('Debugging:: Hide the store locator section.');
					 }
					fnHideStoreLocatorSection();

					 				 }
				 localStorage.setItem(LOCALSTORAGE_TIMEOUT_KEY, 'true');
			 }

					 }
		 dojo.topic.publish('callCompletedforLocationCheck', "Not-AKAMAI");
		 if(_bIsDebuggingEnabled){
			 console.debug('Debugging:: Exiting fnProcessGeoError(oError).');
		 }

		 	 }

		 	 function fnProcessGeoResponse(oPosition){
		 if(_bIsDebuggingEnabled){
			 console.debug('Debugging:: Entering fnProcessGeoResponse(oPosition).');
		 }
		 if(IS_HTML5_CALL_COMPLETED){
			 return;
		 }
		 IS_HTML5_CALL_COMPLETED=true;
		 _geoLatitude = oPosition.coords.latitude;
		 _geoLongitude = oPosition.coords.longitude;

		 		 if(_bIsDebuggingEnabled){
			 console.debug('Debugging:: latitude - ' + _geoLatitude);
			 console.debug('Debugging:: longitude - ' + _geoLongitude);
			 console.debug('Debugging:: Calling fnGetData("latlong")');
		 }
	     fnGetData(LATITUDE_LONGITUDE_API);
	     fnLatitudeLongitudeSetLocalStorage(_geoLatitude,_geoLongitude);
	     if(_bIsDebuggingEnabled){
			 console.debug('Debugging:: Exiting fnProcessGeoResponse(oPosition).');
		 }

	     	 }
	 function fnLatitudeLongitudeSetLocalStorage(lat,long){

		 		 localStorage.removeItem(LOCALSTORAGE_LATITUDE_LONGITUDE_KEY);
		 if(lat != "" && long != ""){
			 var oLatLongRecord = {};
			 oLatLongRecord["latitude"]=lat;
			 oLatLongRecord["longitude"]=long;		 
			 var  nLocationExpirationMS = _nLocationExpirationMin * 60 * 1000;
			 oLatLongRecord["timestamp"]= _timestamp + nLocationExpirationMS;	 
			 localStorage.setItem(LOCALSTORAGE_LATITUDE_LONGITUDE_KEY, JSON.stringify(oLatLongRecord));

			 		 }

	 }


		 	 function fnGetData(requestType,showPreferredStore){
		 if(_bIsDebuggingEnabled){
			 console.debug('Debugging:: Entering fnGetData(requestType).');
			 console.debug('Debugging:: requestType - '+requestType);
		 }
		 if(requestType == NEAREST_STORES_API){
			 if(_bIsDebuggingEnabled){
				 console.debug('Debugging:: Calling fnXHRCall({method: \'POST\', url: fnBuildUrl(NEAREST_STORES_API)});');
			 }
			 fnXHRCall({method: 'POST', url: fnBuildUrl(NEAREST_STORES_API), requestType:NEAREST_STORES_API, dataType: 'json', contentType:'application/json'});

		    		 }else if(requestType == 'AKAMAI_LATLONG'){
			 if(_bIsDebuggingEnabled){
				 console.debug('Debugging:: Calling fnXHRCall({method: \'GET\', url: fnBuildUrl(LATITUDE_LONGITUDE_API)});');
			 }
			var _akamaiCountry= dojo.cookie("Edgescape-Country");
			var _akamaiLatitude= dojo.cookie("Edgescape-Lat");
			var _akamaiLongitude= dojo.cookie("Edgescape-Long");

				 		if(typeof(_akamaiCountry) != "undefined"  && _akamaiCountry =="US" && typeof(_akamaiLatitude) != "undefined" && typeof(_akamaiLongitude) != "undefined"){
	 			_geoLatitude=_akamaiLatitude;
	 			_geoLongitude=_akamaiLongitude;
	 			fnLatitudeLongitudeSetLocalStorage(_geoLatitude,_geoLongitude);
	 			fnXHRCall({method: 'GET', url: fnBuildUrl(LATITUDE_LONGITUDE_API)});
	 		}else{
	 			fnGetData(NEAREST_STORES_API);
	 		}


					 		 }else if(requestType == LATITUDE_LONGITUDE_API){
			 if (typeof(_geoLatitude) != "undefined" && typeof(_geoLongitude) != "undefined" && _geoLatitude != null && _geoLongitude != null) {
				 if(_bIsDebuggingEnabled){
				 console.debug('Debugging:: Calling fnXHRCall({method: \'GET\', url: fnBuildUrl(LATITUDE_LONGITUDE_API)});');
				 }
				 fnXHRCall({method: 'GET', url: fnBuildUrl(LATITUDE_LONGITUDE_API)});
			 } else {
				 if(_bIsDebuggingEnabled){
					 console.debug('Debugging:: Skipping fnXHRCall({method: \'GET\', url: fnBuildUrl(LATITUDE_LONGITUDE_API)}); call since _geoLatitude and _geoLongitude missing.');
				 }
			 }
		 }else if(requestType == ZIPCODE_API){
			 if(typeof(showPreferredStore)!= 'undefined'){
				 fnXHRCall({method: 'POST', url: fnBuildUrl(ZIPCODE_API), requestType:ZIPCODE_API, data: fnZIPCodeData(showPreferredStore), contentType:'application/json'});
			 }else{
			 fnXHRCall({method: 'POST', url: fnBuildUrl(ZIPCODE_API), requestType:ZIPCODE_API, data: fnZIPCodeData(), contentType:'application/json'});
			 }

			 		 }else if(requestType == AKAMAI_ZIPCODE){
			 fnXHRCall({method: 'POST', url: fnBuildUrl(AKAMAI_ZIPCODE), requestType:AKAMAI_ZIPCODE, data: fnAkamaiZIPCodeData(), contentType:'application/json'});
		 }

		 		 if(_bIsDebuggingEnabled){
			 console.debug('Debugging:: Exiting fnGetData(requestType).');
		 }
	 }


	 	 function fnCheckLocalStorage(){
		 if(_bIsDebuggingEnabled){
			 console.debug('Debugging:: Entering fnCheckLocalStorage().');
		 }
		 var oNeareststores = JSON.parse(localStorage.getItem(LOCALSTORAGE_STORES_KEY)) != null ? JSON.parse(localStorage.getItem(LOCALSTORAGE_STORES_KEY)) : {},
		 bGetData = false;
		 if(oNeareststores != null && Object.keys(oNeareststores).length != 0){
			 var petcoStoresLocation = {};

			 			 if(typeof(oNeareststores.petcostores) != "undefined"){
				 petcoStoresLocation =  JSON.parse(oNeareststores.petcostores) != null ? JSON.parse(oNeareststores.petcostores) : {};
			 }

						 if(oNeareststores.timestamp > 0 && _timestamp > oNeareststores.timestamp){
				 localStorage.removeItem(LOCALSTORAGE_STORES_KEY);
				 oNeareststores = {};
				 fnCreateCookie('WC_physicalStores','',-100);
				 bGetData = true;
			 }else if(parseInt(oNeareststores.timestamp) == 0){
				 bGetData = false;
			 }else if(petcoStoresLocation != null && Object.keys(petcoStoresLocation).length == 0){
				 localStorage.removeItem(LOCALSTORAGE_STORES_KEY);
				 oNeareststores = {};
				 fnCreateCookie('WC_physicalStores','',-100);
				 bGetData = true;
			 }
		 }
		 if(oNeareststores == null || Object.keys(oNeareststores).length == 0 || localStorage.getItem(LOCALSTORAGE_TIMEOUT_KEY) == 'true' && Object.keys(oNeareststores.userDetails).length == 0){
			 localStorage.removeItem(LOCALSTORAGE_STORES_KEY);
			 fnCreateCookie('WC_physicalStores','',-100);
			 localStorage.removeItem(LOCALSTORAGE_TIMEOUT_KEY);
			 bGetData = true;
		 }
		 if(_bIsDebuggingEnabled){
			 console.debug('Debugging:: oNeareststores - ' + JSON.stringify(oNeareststores));
			 console.debug('Debugging:: bGetData - ' + bGetData);
			 console.debug('Debugging:: Exiting fnCheckLocalStorage().');
		 }
		 return bGetData;
	 }
	 function fnCheckLocalStorageLatLong(){
		 if(_bIsDebuggingEnabled){
			 console.debug('Debugging:: Entering fnCheckLocalStorageLatLong().');
		 }
		 var oLatLongData = JSON.parse(localStorage.getItem(LOCALSTORAGE_LATITUDE_LONGITUDE_KEY)) != null ? JSON.parse(localStorage.getItem(LOCALSTORAGE_LATITUDE_LONGITUDE_KEY)) : {},
		 bGetData = false;
		 if(oLatLongData != null && Object.keys(oLatLongData).length != 0){
			 if(oLatLongData.timestamp > 0 && _timestamp > oLatLongData.timestamp){
				 localStorage.removeItem(LOCALSTORAGE_LATITUDE_LONGITUDE_KEY);
				 oLatLongData = {};
				 bGetData = true;
			 }else if(parseInt(oLatLongData.timestamp) == 0){
				 bGetData = false;
			 }
		 }else{
			 bGetData = true;
		 }
		 if(_bIsDebuggingEnabled){
			 console.debug('Debugging:: oLatLongData - ' + JSON.stringify(oLatLongData));
			 console.debug('Debugging:: bGetData - ' + bGetData);
			 console.debug('Debugging:: Exiting fnCheckLocalStorageLatLong().');
		 }
		 return bGetData;
	 }


	 var akamaiCalled = false;
	 var NoakamaiCalled = false;
	 function fnSuccessHandler(oData,requestType){

				 if(_bIsDebuggingEnabled){
			 console.debug('Debugging:: Entering fnSuccessHandler(oData).');
		 }
		 var oRecord = {},
		     oStoreHours = {},
		 	 nExpirationMS = _nExpirationMin * 60 * 1000;

		 		 if(oData.hasOwnProperty('location') && requestType == NEAREST_STORES_API){
			 _geoLatitude = oData.location.lat;
			 _geoLongitude = oData.location.lng;
			 fnLatitudeLongitudeSetLocalStorage(_geoLatitude,_geoLongitude);
		     fnGetData(LATITUDE_LONGITUDE_API);
		 }else{
			 if(oData.stores && oData.stores.length > 0){
				 oStoreHours = (oData.storeHours && Object.keys(oData.storeHours).length > 0) ? oData.storeHours : {};
				 if((fnIsPDP() && fnIsBOPUSItem()) || fnIsCartPage()){
					 if(requestType == ZIPCODE_API){
						 fnHideXHRLoader();
						 fnBuildModalUI(oData.stores,oStoreHours);
					 }else{

						 if(parseInt(_nExpirationMin) > 0){
						     oRecord = {"petcostores":JSON.stringify(oData.stores),"shipmodes":JSON.stringify(oData.shipmodedetails),"storehours" : JSON.stringify(oStoreHours),"userDetails":JSON.stringify(oData.userDetails), "timestamp": _timestamp + nExpirationMS};
							 localStorage.setItem(LOCALSTORAGE_STORES_KEY, JSON.stringify(oRecord));
						 }else{
							 oRecord = {"petcostores":JSON.stringify(oData.stores),"shipmodes":JSON.stringify(oData.shipmodedetails),"storehours" : JSON.stringify(oStoreHours), "userDetails":JSON.stringify(oData.userDetails), "timestamp":0};
							 localStorage.setItem(LOCALSTORAGE_STORES_KEY, JSON.stringify(oRecord));
						 }
						 fnSetPhysicalStoreCookie('WC_physicalStores', oData.stores);

						 						 fnBuildStoreInfoUI(oData.stores,'',oStoreHours);
					 }
					 for(i=0; i < oData.stores.length; i++){
						 _tempStoreData.push(oData.stores[i]);
					 }
					 _userData = oData.userDetails;
					 _oStoreHours = oStoreHours;
					if(typeof(oData.shipmodedetails) != 'undefined'){
						 _shipmodedetails = oData.shipmodedetails;
					 }
				 }else{
					 if(parseInt(_nExpirationMin) > 0){
					     oRecord = {"petcostores":JSON.stringify(oData.stores),"shipmodes":JSON.stringify(oData.shipmodedetails),"storehours" : JSON.stringify(oStoreHours),"userDetails":JSON.stringify(oData.userDetails), "timestamp": _timestamp + nExpirationMS};
						 localStorage.setItem(LOCALSTORAGE_STORES_KEY, JSON.stringify(oRecord));
					 }else{
						 oRecord = {"petcostores":JSON.stringify(oData.stores),"shipmodes":JSON.stringify(oData.shipmodedetails),"storehours" : JSON.stringify(oStoreHours), "userDetails":JSON.stringify(oData.userDetails), "timestamp":0};
						 localStorage.setItem(LOCALSTORAGE_STORES_KEY, JSON.stringify(oRecord));
					 }
					 fnSetPhysicalStoreCookie('WC_physicalStores', oData.stores);

					 					 fnBuildStoreInfoUI(oData.stores);
				 }

				 				 localStorage.removeItem(LOCALSTORAGE_TIMEOUT_KEY);
			 }else{

								 if((fnIsPDP() && fnIsBOPUSItem()) || fnIsCartPage()){
					 if(_bIsDebuggingEnabled){
						 console.debug('Debugging:: Hide the store locator section.');
					 }
					 if(requestType == ZIPCODE_API){
						fnHideXHRLoader();

											 	if(_nLastStoreDistance == ''){
							var modalRows = $('.row-set');
							if($(modalRows[0]).is(':visible')){
								$(modalRows).each(function(){
									$(this).remove();
								});
							}

															$('#petco-store-locator-modal').append('<div id="store-locator-error-message" class="col-8 error-box">' + MessageHelper.messages["STORE_LOCATOR_MODAL_ERROR"] + '</div>');
							  $('#load-more-button').removeClass('disabled').addClass('btn-primary').attr('onclick','petcoNearestLocations.fnGetMoreStores();return false;');
							  $('#load-more-button').removeAttr("disabled", "disabled");
							$('#load-more-button').hide();
					 	}else{
					 		$('#load-more-button').addClass('disabled').removeClass('btn-primary').removeAttr('onclick');
					 		 $('#load-more-button').attr("disabled", "disabled");
					 		$('#no-more-stores').show();
					 	}

												return false;
					 }else{
						 if(oData.userDetails && Object.keys(oData.userDetails).length > 0){
							 if(parseInt(_nExpirationMin) > 0){
							     oRecord = {"userDetails":JSON.stringify(oData.userDetails), "timestamp": _timestamp + nExpirationMS};
								 localStorage.setItem(LOCALSTORAGE_STORES_KEY, JSON.stringify(oRecord));
							 }else{
								 oRecord = {"userDetails":JSON.stringify(oData.userDetails), "timestamp":0};
								 localStorage.setItem(LOCALSTORAGE_STORES_KEY, JSON.stringify(oRecord));
							 }
						 }
						fnHideStoreLocatorSection();
					 }


					 									 }else{
					 if(oData.userDetails && Object.keys(oData.userDetails).length > 0){
						 if(parseInt(_nExpirationMin) > 0){
						     oRecord = {"userDetails":JSON.stringify(oData.userDetails), "timestamp": _timestamp + nExpirationMS};
							 localStorage.setItem(LOCALSTORAGE_STORES_KEY, JSON.stringify(oRecord));
						 }else{
							 oRecord = {"userDetails":JSON.stringify(oData.userDetails), "timestamp":0};
							 localStorage.setItem(LOCALSTORAGE_STORES_KEY, JSON.stringify(oRecord));
						 }
					 }else{
					 localStorage.setItem(LOCALSTORAGE_TIMEOUT_KEY, 'true');
				 }

					 				 }
			 }
		 }


				 		 if(_bIsDebuggingEnabled){
			 console.debug('Debugging:: Exiting fnSuccessHandler(oData).');
		 }
		  if(requestType != AKAMAI_ZIPCODE && !NoakamaiCalled){
			  NoakamaiCalled = true
			  dojo.topic.publish('callCompletedforLocationCheck', "Not-AKAMAI");
		  }else if(!akamaiCalled){
			  akamaiCalled = true;
			  dojo.topic.publish('callCompletedforLocationCheck', "AKAMAI");
		  }
		  dojo.topic.publish('BopusAreaRestrictionCheck', "AjaxComplete");	 
		  _populate_Service_location();
	 }


	 function fnErrorHandler(oError,requestType){
		 if(_bIsDebuggingEnabled){
			 console.debug('Debugging:: Entering fnErrorHandler(oError).');
			 console.debug('Debugging:: oError.statusText - ' + oError.statusText );
		 }

				if((fnIsPDP() && fnIsBOPUSItem()) || fnIsCartPage()){
			if(requestType == ZIPCODE_API){
				fnHideXHRLoader();
				if(_nLastStoreDistance == ''){
					var modalRows = $('.row-set');
					if($(modalRows[0]).is(':visible')){
						$(modalRows).each(function(){
							$(this).remove();
						});
					}
					$('#petco-store-locator-modal').append('<div id="store-locator-error-message" class="col-8 error-box">' + MessageHelper.messages["STORE_LOCATOR_MODAL_ERROR"] + '</div>');
					  $('#load-more-button').removeClass('disabled').addClass('btn-primary').attr('onclick','petcoNearestLocations.fnGetMoreStores();return false;');
					  $('#load-more-button').removeAttr("disabled", "disabled");
					$('#load-more-button').hide();
					$('#no-more-stores').hide();
				}

								return false;
			}else{
				if(_bIsDebuggingEnabled){
					 console.debug('Debugging:: Hide the store locator section.');
				 }
				if(oError.statusText == 'timeout' || oError.statusText == 'error'){
					localStorage.setItem(LOCALSTORAGE_TIMEOUT_KEY, 'true');
				}
				fnHideStoreLocatorSection();
				 localStorage.removeItem(LOCALSTORAGE_STORES_KEY);
				 fnCreateCookie('WC_physicalStores','',-100);
			}

					}else{
			if(oError.statusText == 'timeout' || oError.statusText == 'error'){
				localStorage.setItem(LOCALSTORAGE_TIMEOUT_KEY, 'true');
				 localStorage.removeItem(LOCALSTORAGE_STORES_KEY);
				 fnCreateCookie('WC_physicalStores','',-100);
			}
		}
		if(requestType != AKAMAI_ZIPCODE){
			  dojo.topic.publish('callCompletedforLocationCheck', "Not-AKAMAI");
		  }else{
			  dojo.topic.publish('callCompletedforLocationCheck', "AKAMAI");
		  }
		if(_bIsDebuggingEnabled){
			 console.debug('Debugging:: Exiting fnErrorHandler(oError).');
		 }
	 }



		 function fnIsCartPage(){
			 if(_bIsDebuggingEnabled){
				 console.debug('Debugging:: Entering fnIsCartPage().');
			 }
			 var bIsCART = false,
			 	 elCARTContainer = $('div.cart-product-listing div.standard-products-list div.cart-product-details');
			 if(elCARTContainer.length > 0){
				 bIsCART = true;
			 }else{
				 elCARTContainer = $('article.cart-product-item');
				 if(elCARTContainer.length > 0){
					 bIsCART = true;
				 }
			 }
			 if(_bIsDebuggingEnabled){
				 console.debug('Debugging:: Exiting fnIsCartPage().');
				 console.debug('Debugging:: fnIsCartPage - '+ fnIsCartPage);
			 }
			 return bIsCART;
		 }


	 function fnIsPDP(){
		 if(_bIsDebuggingEnabled){
			 console.debug('Debugging:: Entering fnIsPDP().');
		 }
		 var bIsPDP = false,
		 	 elPDPContainer = $('div[data-pageType="product-detail-page"]');
		 if(elPDPContainer.length > 0){
			 bIsPDP = true;
		 }
		 if(_bIsDebuggingEnabled){
			 console.debug('Debugging:: Exiting fnIsPDP().');
			 console.debug('Debugging:: bIsPDP - '+ bIsPDP);
		 }
		 return bIsPDP;
	 }


	 function fnBuildStoreInfoUI(oStoreData,availability,oStoreHours){

				 if(_bIsDebuggingEnabled){
			 console.debug('Debugging:: Entering fnBuildStoreInfoUI(oStoreData).');
		 }
		var oNearestStores = {},
			oPhysicalStoreHours = {},
		    aPetcostores = [],
		    sAvailability = availability || '',
		    sStoreHoursContent = '',
		    sPhysicalStoreName = '';
		$('#storeZipCode').val('');
		if(oStoreData && typeof(oStoreData) != 'undefined'){

						oNearestStores = oStoreData[0];
			if(oNearestStores.isPreferred == 'Y') {
				if(oStoreData.length > 1){
				$('#storeZipCode').val(oStoreData[1].ZIPCODE);
			} else {
					$('#storeZipCode').val(oNearestStores.ZIPCODE);
				}	
			} else {
				$('#storeZipCode').val(oNearestStores.ZIPCODE);
			}
		}else{
			var oStoreDataTMP = JSON.parse(localStorage.getItem(LOCALSTORAGE_STORES_KEY));
			var oStoreDatastoresTMP = JSON.parse(oStoreDataTMP.petcostores);
			if(typeof(oStoreDataTMP.petcostores) != 'undefined' && oStoreDatastoresTMP.length > 0 ){	
				setTimeout(function(){checkIfStoreStatusAndClearStorage(JSON.parse(oStores.petcostores));},500);
			aPetcostores = JSON.parse(oStoreDataTMP.petcostores);
			for(i=0; i < aPetcostores.length; i++){
				 _tempStoreData.push(aPetcostores[i]);
			 }

			oNearestStores = aPetcostores[0];


									if(oNearestStores.isPreferred == 'Y') {
				if(aPetcostores.length > 1){
					$('#storeZipCode').val(aPetcostores[1].ZIPCODE);
				}else{
					$('#storeZipCode').val(oNearestStores.ZIPCODE);
				}			
			} else {
				$('#storeZipCode').val(oNearestStores.ZIPCODE);
			}
		}
		}
		if(oStoreHours != null && oStoreHours != '' && typeof(oStoreHours) != 'undefined'){
			oPhysicalStoreHours = oStoreHours;
		}else{
			var oStores = JSON.parse(localStorage.getItem(LOCALSTORAGE_STORES_KEY));
			if(typeof(oStores.storehours) != 'undefined'){
			oPhysicalStoreHours = JSON.parse(oStores.storehours);
		}
		}
		var storeDetailsURL = "PetcoStoreDetailsView?storeId=" + WCParamJS.storeId + "&catalogId=" + WCParamJS.catalogId + "&langId=" + WCParamJS.langId + "&stlocId=" + oNearestStores.IDENTIFIER;
		if(oNearestStores != null && Object.keys(oNearestStores).length > 0){
			fnHideStoreLink();

						var bopusSelectStails = document.getElementById("bopusSelectStails");
			if(bopusSelectStails != null && bopusSelectStails.value == 'true'){
				var instockstatusSelectable = $('#bopusdeailsInStockSelectable'),
					outstockstatusSelectable = $('#bopusdeailsNotAvailableSelectable'),
					lowstockstatusSelectable = $('#bopusdeailsLowInventorySelectable');	
				var bopusSelectEnabledBopusAttrOn = document.getElementById("bopusSelectEnabledBopusAttrOn");
				if(bopusSelectEnabledBopusAttrOn != null ){
					bopusSelectEnabledBopusAttrOn.classList.add("show");
					bopusSelectEnabledBopusAttrOn.classList.remove("hide");
				}else if(bopusSelectEnabledBopusAttrOn != null){
					bopusSelectEnabledBopusAttrOn.classList.add("hide");
					bopusSelectEnabledBopusAttrOn.classList.remove("show");
					setTimeout(function(){productDisplayJS.addBOPUSDetailsForInstock(oNearestStores.STATE)},1000);
				}
				if(sAvailability != ''){
					if(sAvailability == 'Available'){
						instockstatusSelectable.removeClass('hide');
						instockstatusSelectable.addClass('show');
						outstockstatusSelectable.removeClass('show');
						outstockstatusSelectable.addClass('hide');
						lowstockstatusSelectable.removeClass('show');
						lowstockstatusSelectable.addClass('hide');

											}else{
						instockstatusSelectable.removeClass('show');
						instockstatusSelectable.addClass('hide');
						outstockstatusSelectable.removeClass('hide');
						outstockstatusSelectable.addClass('show');
						lowstockstatusSelectable.removeClass('show');
						lowstockstatusSelectable.addClass('hide');
					}
				}
				sPhysicalStoreName = oNearestStores.DSNAME;
				if(typeof(sPhysicalStoreName) != 'undefined'){
				if(sPhysicalStoreName.toLowerCase().indexOf('unleashed') != -1 && sPhysicalStoreName.lastIndexOf('-') != -1){
					$('span.selectableBopusSection .show .lsa-location').html(sPhysicalStoreName.replace('-', '<br>'));
					$('span#frozenFood .lsa-location').html(sPhysicalStoreName.replace('-', '<br>'));

									}else{
					$('span.selectableBopusSection .show .lsa-location').html(sPhysicalStoreName);
					$('span#frozenFood .lsa-location').html(sPhysicalStoreName);
				}

								}
				if(oNearestStores.ADDRESS2 != null && oNearestStores.ADDRESS2 != ''){
					$('span.selectableBopusSection .show .lsa-street-address').text(oNearestStores.ADDRESS1 + ' ' + oNearestStores.ADDRESS2);
					$('span#frozenFood .lsa-street-address').text(oNearestStores.ADDRESS1 + ' ' + oNearestStores.ADDRESS2);
				}else{
					$('span.selectableBopusSection .show .lsa-street-address').text(oNearestStores.ADDRESS1);
					$('span#frozenFood .lsa-street-address').text(oNearestStores.ADDRESS1);
				}
				$('#CurrentBOPUSState').val(oNearestStores.STATE);
				$('span.selectableBopusSection .show .lsa-city-state-zip').html(oNearestStores.CITY + ', ' + oNearestStores.STATE + '&nbsp;<span id="store-loc-zip-code">' + oNearestStores.ZIPCODE + '</span>');
				$('span.selectableBopusSection .show .lsa-phone').text(oNearestStores.PHONE);
				$('span#frozenFood .lsa-city-state-zip').html(oNearestStores.CITY + ', ' + oNearestStores.STATE + '&nbsp;<span id="store-loc-zip-code">' + oNearestStores.ZIPCODE + '</span>');
				$('span#frozenFood .lsa-phone').text(oNearestStores.PHONE);
				var date = new Date();
				var currentdate = new Date();
				if(oPhysicalStoreHours.hasOwnProperty(oNearestStores.IDENTIFIER)){
					if(oPhysicalStoreHours[oNearestStores.IDENTIFIER].T1OPEN == '00:00:00' && oPhysicalStoreHours[oNearestStores.IDENTIFIER].T1CLOSE == '00:00:00'){
						sStoreHoursContent = '<strong>Mon</strong><span>Closed</span><br/>';
					}else{
						sStoreHoursContent = '<strong>Mon</strong><span>'+ fnToDateTimeFormat(oPhysicalStoreHours[oNearestStores.IDENTIFIER].T1OPEN.substring(0,oPhysicalStoreHours[oNearestStores.IDENTIFIER].T1OPEN.lastIndexOf(":"))) +' - ' + fnToDateTimeFormat(oPhysicalStoreHours[oNearestStores.IDENTIFIER].T1CLOSE.substring(0,oPhysicalStoreHours[oNearestStores.IDENTIFIER].T1CLOSE.lastIndexOf(":"))) + '</span><br/>';
						if(date.getDay() == '1' && oPhysicalStoreHours[oNearestStores.IDENTIFIER].T1CLOSE != null)
						{
							date.setHours(oPhysicalStoreHours[oNearestStores.IDENTIFIER].T1CLOSE.substring(0,2),0,0,0);
							if(date.getHours() - currentdate.getHours()<= 2)
								$("#bopus-option").text($("#bopusTitle_noRD").val());
						}
					}

										if(oPhysicalStoreHours[oNearestStores.IDENTIFIER].T2OPEN == '00:00:00' && oPhysicalStoreHours[oNearestStores.IDENTIFIER].T2CLOSE == '00:00:00'){
						sStoreHoursContent += '<strong>Tue</strong><span>Closed</span><br/>';
					}else{
						sStoreHoursContent += '<strong>Tue</strong><span>'+ fnToDateTimeFormat(oPhysicalStoreHours[oNearestStores.IDENTIFIER].T2OPEN.substring(0,oPhysicalStoreHours[oNearestStores.IDENTIFIER].T2OPEN.lastIndexOf(":"))) +' - ' + fnToDateTimeFormat(oPhysicalStoreHours[oNearestStores.IDENTIFIER].T2CLOSE.substring(0,oPhysicalStoreHours[oNearestStores.IDENTIFIER].T2CLOSE.lastIndexOf(":"))) + '</span><br/>';
						if(date.getDay() == '2' && oPhysicalStoreHours[oNearestStores.IDENTIFIER].T2CLOSE != null)
						{
							date.setHours(oPhysicalStoreHours[oNearestStores.IDENTIFIER].T2CLOSE.substring(0,2),0,0,0);
							if(date.getHours() - currentdate.getHours()<= 2)
								$("#bopus-option").text($("#bopusTitle_noRD").val());
						}
					}

										if(oPhysicalStoreHours[oNearestStores.IDENTIFIER].T3OPEN == '00:00:00' && oPhysicalStoreHours[oNearestStores.IDENTIFIER].T3CLOSE == '00:00:00'){
						sStoreHoursContent += '<strong>Wed</strong><span>Closed</span><br/>';
					}else{
						sStoreHoursContent += '<strong>Wed</strong><span>'+ fnToDateTimeFormat(oPhysicalStoreHours[oNearestStores.IDENTIFIER].T3OPEN.substring(0,oPhysicalStoreHours[oNearestStores.IDENTIFIER].T3OPEN.lastIndexOf(":"))) +' - ' + fnToDateTimeFormat(oPhysicalStoreHours[oNearestStores.IDENTIFIER].T3CLOSE.substring(0,oPhysicalStoreHours[oNearestStores.IDENTIFIER].T3CLOSE.lastIndexOf(":"))) + '</span><br/>';
						if(date.getDay() == '3' && oPhysicalStoreHours[oNearestStores.IDENTIFIER].T3CLOSE != null)
						{
							date.setHours(oPhysicalStoreHours[oNearestStores.IDENTIFIER].T3CLOSE.substring(0,2),0,0,0);
							if(date.getHours() - currentdate.getHours()<= 2)
								$("#bopus-option").text($("#bopusTitle_noRD").val());
						}
					}

										if(oPhysicalStoreHours[oNearestStores.IDENTIFIER].T4OPEN == '00:00:00' && oPhysicalStoreHours[oNearestStores.IDENTIFIER].T4CLOSE == '00:00:00'){
						sStoreHoursContent += '<strong>Thu</strong><span>Closed</span><br/>';
					}else{
						sStoreHoursContent += '<strong>Thu</strong><span>'+ fnToDateTimeFormat(oPhysicalStoreHours[oNearestStores.IDENTIFIER].T4OPEN.substring(0,oPhysicalStoreHours[oNearestStores.IDENTIFIER].T4OPEN.lastIndexOf(":"))) +' - ' + fnToDateTimeFormat(oPhysicalStoreHours[oNearestStores.IDENTIFIER].T4CLOSE.substring(0,oPhysicalStoreHours[oNearestStores.IDENTIFIER].T4CLOSE.lastIndexOf(":"))) + '</span><br/>';
						if(date.getDay() == '4' && oPhysicalStoreHours[oNearestStores.IDENTIFIER].T4CLOSE != null)
						{
							date.setHours(oPhysicalStoreHours[oNearestStores.IDENTIFIER].T4CLOSE.substring(0,2),0,0,0);
							if(date.getHours() - currentdate.getHours()<= 2)
								$("#bopus-option").text($("#bopusTitle_noRD").val());
						}
					}

										if(oPhysicalStoreHours[oNearestStores.IDENTIFIER].T5OPEN == '00:00:00' && oPhysicalStoreHours[oNearestStores.IDENTIFIER].T5CLOSE == '00:00:00'){
						sStoreHoursContent += '<strong>Fri</strong><span>Closed</span><br/>';
					}else{
						sStoreHoursContent += '<strong>Fri</strong><span>'+ fnToDateTimeFormat(oPhysicalStoreHours[oNearestStores.IDENTIFIER].T5OPEN.substring(0,oPhysicalStoreHours[oNearestStores.IDENTIFIER].T5OPEN.lastIndexOf(":"))) +' - ' + fnToDateTimeFormat(oPhysicalStoreHours[oNearestStores.IDENTIFIER].T5CLOSE.substring(0,oPhysicalStoreHours[oNearestStores.IDENTIFIER].T5CLOSE.lastIndexOf(":"))) + '</span><br/>';
						if(date.getDay() == '5' && oPhysicalStoreHours[oNearestStores.IDENTIFIER].T5CLOSE != null)
						{
							date.setHours(oPhysicalStoreHours[oNearestStores.IDENTIFIER].T5CLOSE.substring(0,2),0,0,0);
							if(date.getHours() - currentdate.getHours()<= 2)
								$("#bopus-option").text($("#bopusTitle_noRD").val());
						}
					}

										if(oPhysicalStoreHours[oNearestStores.IDENTIFIER].T6OPEN == '00:00:00' && oPhysicalStoreHours[oNearestStores.IDENTIFIER].T6CLOSE == '00:00:00'){
						sStoreHoursContent += '<strong>Sat</strong><span>Closed</span><br/>';
					}else{
						sStoreHoursContent += '<strong>Sat</strong><span>'+ fnToDateTimeFormat(oPhysicalStoreHours[oNearestStores.IDENTIFIER].T6OPEN.substring(0,oPhysicalStoreHours[oNearestStores.IDENTIFIER].T6OPEN.lastIndexOf(":"))) +' - ' + fnToDateTimeFormat(oPhysicalStoreHours[oNearestStores.IDENTIFIER].T6CLOSE.substring(0,oPhysicalStoreHours[oNearestStores.IDENTIFIER].T6CLOSE.lastIndexOf(":"))) + '</span><br/>';
						if(date.getDay() == '6' && oPhysicalStoreHours[oNearestStores.IDENTIFIER].T6CLOSE != null)
						{
							date.setHours(oPhysicalStoreHours[oNearestStores.IDENTIFIER].T6CLOSE.substring(0,2),0,0,0);
							if(date.getHours() - currentdate.getHours()<= 2)
								$("#bopus-option").text($("#bopusTitle_noRD").val());
						}
					}

										if(oPhysicalStoreHours[oNearestStores.IDENTIFIER].T7OPEN == '00:00:00' && oPhysicalStoreHours[oNearestStores.IDENTIFIER].T7CLOSE == '00:00:00'){
						sStoreHoursContent += '<strong>Sun</strong><span>Closed</span>';
					}else{
						sStoreHoursContent += '<strong>Sun</strong><span>'+ fnToDateTimeFormat(oPhysicalStoreHours[oNearestStores.IDENTIFIER].T7OPEN.substring(0,oPhysicalStoreHours[oNearestStores.IDENTIFIER].T7OPEN.lastIndexOf(":"))) +' - ' + fnToDateTimeFormat(oPhysicalStoreHours[oNearestStores.IDENTIFIER].T7CLOSE.substring(0,oPhysicalStoreHours[oNearestStores.IDENTIFIER].T7CLOSE.lastIndexOf(":"))) + '</span>';
						if(date.getDay() == '0' && oPhysicalStoreHours[oNearestStores.IDENTIFIER].T7CLOSE != null)
						{
							date.setHours(oPhysicalStoreHours[oNearestStores.IDENTIFIER].T7CLOSE.substring(0,2),0,0,0);
							if(date.getHours() - currentdate.getHours()<= 2)
								$("#bopus-option").text($("#bopusTitle_noRD").val());
						}
					}
					$('span.selectableBopusSection .show .lsa-hours').html('<a tabindex="0" href="javascript:void(0)" data-placement="top" data-html="true" data-toggle="popover" data-trigger="click" data-content="'+sStoreHoursContent+'">Store Hours</a>');
					$('span#frozenFood .lsa-hours').html('<a tabindex="0" href="javascript:void(0)" data-placement="top" data-toggle="popover" data-html="true" data-trigger="click" data-content="'+sStoreHoursContent+'">Store Hours</a>');

									}

								if(($('#bopusdeailsNotAvailableSelectable.show').length > 0 || $('#bopusdeailsLowInventorySelectable.show').length > 0) && $('#add2CartBtn_bopus').length > 0){
					$('#add2CartBtn_bopus')[0].innerHTML="Not Available";
					$('#add2CartBtn_bopus')[0].disabled = true;
				}else if(($('#bopusdeailsInStockSelectable.show').length > 0) && $('#add2CartBtn_bopus').length > 0){
					$('#add2CartBtn_bopus')[0].innerHTML="Add to Cart";
					$('#add2CartBtn_bopus')[0].disabled = false;
					if($("#pdp_atc").parent().length > 0 && $("#pdp_atc").parent()[0].classList.contains("hide")){
						 $("#pdp_atc").parent().removeClass('hide');
					}
				}
			}else{
				var instockstatus = $('#bopusdeailsInStock'),
				outstockstatus = $('#bopusdeailsNotAvailable'),
				lowstockstatus = $('#bopusdeailsLowInventory');	
				if(sAvailability != ''){
					if(sAvailability == 'Available'){
						instockstatus.removeClass('hide');
						instockstatus.addClass('show');
						outstockstatus.removeClass('show');
						outstockstatus.addClass('hide');
						lowstockstatus.removeClass('show');
						lowstockstatus.addClass('hide');

					}else{
						instockstatus.removeClass('show');
						instockstatus.addClass('hide');
						outstockstatus.removeClass('hide');
						outstockstatus.addClass('show');
						lowstockstatus.removeClass('show');
						lowstockstatus.addClass('hide');
					}
				}
				sPhysicalStoreName = oNearestStores.DSNAME;
				if(sPhysicalStoreName.toLowerCase().indexOf('unleashed') != -1 && sPhysicalStoreName.lastIndexOf("-") != -1){
					$('#store-name').html(sPhysicalStoreName.replace('-', '<br>'));
				}else{
					$('#store-name').html(sPhysicalStoreName);
				}

								if(oNearestStores.ADDRESS2 != null && oNearestStores.ADDRESS2 != ''){
					$('#store-street-address').text(oNearestStores.ADDRESS1 + ' ' + oNearestStores.ADDRESS2);

									}else{
					$('#store-street-address').text(oNearestStores.ADDRESS1);
				}

								$('#store-city-state-zip').html(oNearestStores.CITY + ', ' + oNearestStores.STATE + '&nbsp;<span id="store-loc-zip-code">' + oNearestStores.ZIPCODE + '</span>');
				$('#store-phone').text(oNearestStores.PHONE);
				if(oPhysicalStoreHours.hasOwnProperty(oNearestStores.IDENTIFIER)){
					if(oPhysicalStoreHours[oNearestStores.IDENTIFIER].T1OPEN == '00:00:00' && oPhysicalStoreHours[oNearestStores.IDENTIFIER].T1CLOSE == '00:00:00'){
						sStoreHoursContent = '<strong>Mon</strong><span>Closed</span><br/>';
					}else{
						sStoreHoursContent = '<strong>Mon</strong><span>'+ fnToDateTimeFormat(oPhysicalStoreHours[oNearestStores.IDENTIFIER].T1OPEN.substring(0,oPhysicalStoreHours[oNearestStores.IDENTIFIER].T1OPEN.lastIndexOf(":"))) +' - ' + fnToDateTimeFormat(oPhysicalStoreHours[oNearestStores.IDENTIFIER].T1CLOSE.substring(0,oPhysicalStoreHours[oNearestStores.IDENTIFIER].T1CLOSE.lastIndexOf(":"))) + '</span><br/>';
					}

										if(oPhysicalStoreHours[oNearestStores.IDENTIFIER].T2OPEN == '00:00:00' && oPhysicalStoreHours[oNearestStores.IDENTIFIER].T2CLOSE == '00:00:00'){
						sStoreHoursContent += '<strong>Tue</strong><span>Closed</span><br/>';
					}else{
						sStoreHoursContent += '<strong>Tue</strong><span>'+ fnToDateTimeFormat(oPhysicalStoreHours[oNearestStores.IDENTIFIER].T2OPEN.substring(0,oPhysicalStoreHours[oNearestStores.IDENTIFIER].T2OPEN.lastIndexOf(":"))) +' - ' + fnToDateTimeFormat(oPhysicalStoreHours[oNearestStores.IDENTIFIER].T2CLOSE.substring(0,oPhysicalStoreHours[oNearestStores.IDENTIFIER].T2CLOSE.lastIndexOf(":"))) + '</span><br/>';
					}

										if(oPhysicalStoreHours[oNearestStores.IDENTIFIER].T3OPEN == '00:00:00' && oPhysicalStoreHours[oNearestStores.IDENTIFIER].T3CLOSE == '00:00:00'){
						sStoreHoursContent += '<strong>Wed</strong><span>Closed</span><br/>';
					}else{
						sStoreHoursContent += '<strong>Wed</strong><span>'+ fnToDateTimeFormat(oPhysicalStoreHours[oNearestStores.IDENTIFIER].T3OPEN.substring(0,oPhysicalStoreHours[oNearestStores.IDENTIFIER].T3OPEN.lastIndexOf(":"))) +' - ' + fnToDateTimeFormat(oPhysicalStoreHours[oNearestStores.IDENTIFIER].T3CLOSE.substring(0,oPhysicalStoreHours[oNearestStores.IDENTIFIER].T3CLOSE.lastIndexOf(":"))) + '</span><br/>';
					}

										if(oPhysicalStoreHours[oNearestStores.IDENTIFIER].T4OPEN == '00:00:00' && oPhysicalStoreHours[oNearestStores.IDENTIFIER].T4CLOSE == '00:00:00'){
						sStoreHoursContent += '<strong>Thu</strong><span>Closed</span><br/>';
					}else{
						sStoreHoursContent += '<strong>Thu</strong><span>'+ fnToDateTimeFormat(oPhysicalStoreHours[oNearestStores.IDENTIFIER].T4OPEN.substring(0,oPhysicalStoreHours[oNearestStores.IDENTIFIER].T4OPEN.lastIndexOf(":"))) +' - ' + fnToDateTimeFormat(oPhysicalStoreHours[oNearestStores.IDENTIFIER].T4CLOSE.substring(0,oPhysicalStoreHours[oNearestStores.IDENTIFIER].T4CLOSE.lastIndexOf(":"))) + '</span><br/>';
					}

										if(oPhysicalStoreHours[oNearestStores.IDENTIFIER].T5OPEN == '00:00:00' && oPhysicalStoreHours[oNearestStores.IDENTIFIER].T5CLOSE == '00:00:00'){
						sStoreHoursContent += '<strong>Fri</strong><span>Closed</span><br/>';
					}else{
						sStoreHoursContent += '<strong>Fri</strong><span>'+ fnToDateTimeFormat(oPhysicalStoreHours[oNearestStores.IDENTIFIER].T5OPEN.substring(0,oPhysicalStoreHours[oNearestStores.IDENTIFIER].T5OPEN.lastIndexOf(":"))) +' - ' + fnToDateTimeFormat(oPhysicalStoreHours[oNearestStores.IDENTIFIER].T5CLOSE.substring(0,oPhysicalStoreHours[oNearestStores.IDENTIFIER].T5CLOSE.lastIndexOf(":"))) + '</span><br/>';
					}

										if(oPhysicalStoreHours[oNearestStores.IDENTIFIER].T6OPEN == '00:00:00' && oPhysicalStoreHours[oNearestStores.IDENTIFIER].T6CLOSE == '00:00:00'){
						sStoreHoursContent += '<strong>Sat</strong><span>Closed</span><br/>';
					}else{
						sStoreHoursContent += '<strong>Sat</strong><span>'+ fnToDateTimeFormat(oPhysicalStoreHours[oNearestStores.IDENTIFIER].T6OPEN.substring(0,oPhysicalStoreHours[oNearestStores.IDENTIFIER].T6OPEN.lastIndexOf(":"))) +' - ' + fnToDateTimeFormat(oPhysicalStoreHours[oNearestStores.IDENTIFIER].T6CLOSE.substring(0,oPhysicalStoreHours[oNearestStores.IDENTIFIER].T6CLOSE.lastIndexOf(":"))) + '</span><br/>';
					}

										if(oPhysicalStoreHours[oNearestStores.IDENTIFIER].T7OPEN == '00:00:00' && oPhysicalStoreHours[oNearestStores.IDENTIFIER].T7CLOSE == '00:00:00'){
						sStoreHoursContent += '<strong>Sun</strong><span>Closed</span>';
					}else{
						sStoreHoursContent += '<strong>Sun</strong><span>'+ fnToDateTimeFormat(oPhysicalStoreHours[oNearestStores.IDENTIFIER].T7OPEN.substring(0,oPhysicalStoreHours[oNearestStores.IDENTIFIER].T7OPEN.lastIndexOf(":"))) +' - ' + fnToDateTimeFormat(oPhysicalStoreHours[oNearestStores.IDENTIFIER].T7CLOSE.substring(0,oPhysicalStoreHours[oNearestStores.IDENTIFIER].T7CLOSE.lastIndexOf(":"))) + '</span>';
					}
					$('#store-hours').html('<a href="javascript:void(0)" data-placement="top" data-toggle="popover" data-trigger="hover" data-content="'+sStoreHoursContent+'">Store Hours</a>');
				}

							}



												if($('#modal-neareststores').is(':visible')){
				fnCloseStoreInfoModal();
			}

					}else{
			fnDisplayStoreLink();
		}

				if(_bIsDebuggingEnabled){
			 console.debug('Debugging:: oNearestStores - ' + oNearestStores);
			 console.debug('Debugging:: Exiting fnBuildStoreInfoUI(oStoreData).');
		 }


		 		 	 }

	 	 function fnIsStoreClosed(openingHours, closingHours){
		 if(openingHours === null || openingHours === '' || openingHours.indexOf(':') == -1 || closingHours === null || closingHours === '' || closingHours.indexOf(':') == -1){
			 return false;
		 }else{
			 var nStoreOpeningHour = parseInt(openingHours.split(':')[0]),
		 	 nStoreClosingHour = parseInt(closingHours.split(':')[0]),
		 	 nCurrentHour = new Date().getHours(),
		 	 bIsStoreClosed = false;

		 			 if(nCurrentHour < nStoreOpeningHour || nCurrentHour >= nStoreClosingHour){
				 bIsStoreClosed = true;
			 }

			 			 return bIsStoreClosed;
		 }

		 	 }


	 function fnDisplayStoreLink(){
		 if(_bIsDebuggingEnabled){
			 console.debug('Debugging:: Entering fnDisplayStoreLink().');
		 }
			if($('#isBOPUSHide').length != 0){
				$('#isBOPUSHide')[0].value="no";
			}
		 $('#select-store-link').show();
		 $('#bopis-store-info').hide();
		 dojo.topic.publish('ChangeBasedOnLocationCallCompleted', "show");
		 if(_bIsDebuggingEnabled){
			 console.debug('Debugging:: Exiting fnDisplayStoreLink().');
		 }
	 }


	 function fnHideStoreLink(){
		 if(_bIsDebuggingEnabled){
			 console.debug('Debugging:: Entering fnHideStoreLink().');
		 }
		 if($('#isBOPUSHide').length != 0){
				$('#isBOPUSHide')[0].value="no";
			}
		 $('#select-store-link').hide();
		 $('#bopis-store-info').show();
		 dojo.topic.publish('ChangeBasedOnLocationCallCompleted', "show");
		 if(_bIsDebuggingEnabled){
			 console.debug('Debugging:: Exiting fnHideStoreLink().');
		 }
	 }


	 function fnHideStoreLocatorSection(){
		 if(_bIsDebuggingEnabled){
			 console.debug('Debugging:: Entering fnHideStoreLocatorSection().');
		 }
		if($('#isBOPUSHide').length != 0){
			$('#isBOPUSHide')[0].value="yes";
		}
		 dojo.topic.publish('ChangeBasedOnLocationCallCompleted', "hide");
		 if(_bIsDebuggingEnabled){
			 console.debug('Debugging:: Exiting fnHideStoreLocatorSection().');
		 }
	 }


	 function fnSetPhysicalStoreCookie(cookieName,storeData){
		 if(_bIsDebuggingEnabled){
			 console.debug('Debugging:: Entering fnSetPhysicalStoreCookie(cookieName).');
			 console.debug('Debugging:: storeData - ' + JSON.stringify(storeData));
		 }

		 		 var len = storeData.length <= 5 ? storeData.length : 5,
		 	 cookieValue = '';
		 for(i=0;i < len;i++){
				 cookieValue += storeData[i].STLOC_ID + (i != (len -1) ? '%2C' : '');
		 }
		 var expiry = $("#expirationMin");
		 fnCreateCookie(cookieName,cookieValue,expiry.val());
		 if(cookieValue != ''){
			 dojo.topic.publish('cookieAddedForPhysicalStoreId', cookieValue);
		 }
		 if(_bIsDebuggingEnabled){
			 console.debug('Debugging:: cookieName - ' + cookieName);
			 console.debug('Debugging:: cookieValue - ' + cookieValue);
			 console.debug('Debugging:: Exiting fnSetPhysicalStoreCookie(cookieName).');
		 }
	 }


		 	 function fnCreateCookie(name, value, mins){
		 if(_bIsDebuggingEnabled){
			 console.debug('Debugging:: Entering fnCreateCookie(name, value, mins).');
			 console.debug('Debugging:: name - ' + name);
			 console.debug('Debugging:: value - ' + value);
			 console.debug('Debugging:: mins - ' + mins);
		 }
		var expires;
		var hostName = document.location.hostname;
		var domainName = hostName.substring(hostName.lastIndexOf(".", hostName.lastIndexOf(".") - 1));

			    if (mins) {
	        var date = new Date();
	        date.setTime(date.getTime()+(mins*60*1000));
	        expires = '; expires='+date.toGMTString();
	    }
	    else {
	        expires = '';
	    }
	    document.cookie = name+'='+value+expires+';path=/';
	    if(_bIsDebuggingEnabled){
	    	console.debug('Debugging:: Exiting fnCreateCookie(name, value, mins).');
	    }
	 }


		 	 function fnIsBOPUSItem(){
		 if(_bIsDebuggingEnabled){
			 console.debug('Debugging:: Entering fnIsBOPUSItem().');
		 }
		var bIsBOPUSItem = false,
		    elIsBOPUSEnabledItem = (document.getElementById('isBOPUSEnabledItem')!= null && document.getElementById('isBOPUSEnabledItem') != undefined) ? document.getElementById('isBOPUSEnabledItem').value : '';

				if(elIsBOPUSEnabledItem != '' && elIsBOPUSEnabledItem != null){
			if(elIsBOPUSEnabledItem.toLowerCase() == 'yes'){
				bIsBOPUSItem = true;
			}
		}

				return bIsBOPUSItem;

	    	    if(_bIsDebuggingEnabled){
	    	console.debug('Debugging:: Exiting fnIsBOPUSItem().');
	    }
	 }


			 	 function fnBuildModalUI(storeData,storeHours){
		 if(_bIsDebuggingEnabled){
			 console.debug('Debugging:: Entering fnBuildModalUI(storeData).');
		 }

		 		 var aNearestStores = [],
		 	 modalRows = $('.row-set'),
		 	 sStoreHTML = '',
		 	 sStoreLoc = '',
		 	 sCSSClass = '',
		 	 sFullStreetAddress = '',
		 	 nDistance = '',
			 sStoreType = '',
			 sImgSrc = '',
			 sStreetAddress1 = '',
			 sStreetAddress2 = '',
			 sStoreName = '',
			 sCity = '',
			 sState = '',
			 sZipCode = '',
			 sPhone = '',
			 sAvailability = '',
			 sBopusEnabled = '',
			 oPhysicalStoreHours = {},
			 sStoreHoursContent = '',
			 sStoreOpenUntil = '',
			 oStoreEventJSON = {},
			 aStoreIdentifier = [];

		 if(_nLastStoreDistance == ''){
		 if($(modalRows).is(':visible')){
				$(modalRows).each(function(){
					$(this).remove();
				});
			}
		 }

		 if(storeData){
			aNearestStores = storeData;			
		 }else{
			var oNearestStores = JSON.parse(localStorage.getItem(LOCALSTORAGE_STORES_KEY));
			if(Object.keys(oNearestStores).length > 0){
				aNearestStores = JSON.parse(oNearestStores.petcostores);
				aNearestStores.sort(fnGetSortOrder('DISTANCE'));

							}
		 }

		 		 if(storeHours != null && storeHours != ''){
			 oPhysicalStoreHours = storeHours;
		 }else{
			var oStores = JSON.parse(localStorage.getItem(LOCALSTORAGE_STORES_KEY));
			oPhysicalStoreHours = JSON.parse(oStores.storehours);
		 }

		 		 if(aNearestStores.length > 0){
			 for(i=0;i < aNearestStores.length;i++){
				 sStoreLoc += aNearestStores[i].STLOC_ID + (i != (aNearestStores.length - 1) ? ',' : '');
			 }
			 fnGetInventory(sStoreLoc);
			 for(i=0;i < aNearestStores.length;i++){
			 	 nDistance = aNearestStores[i].DISTANCE != null ? aNearestStores[i].DISTANCE : '';	
			 	 sStoreType = aNearestStores[i].PETCOSTORE != null ? aNearestStores[i].PETCOSTORE : '';			
			 	 if(document.querySelectorAll(".petcoNextStoreLocatorModal").length > 0){
			 		 sImgSrc =    (sStoreType.indexOf('PETCO') != -1) ? PETCO_NEXT_STORE_LOGO : UNLEASHED_NEXT_STORE_LOGO; 		
			 	 }else{
			 		 sImgSrc =    (sStoreType.indexOf('PETCO') != -1) ? PETCO_STORE_LOGO : UNLEASHED_STORE_LOGO; 		
			 	 }		 	 
			 	 sStreetAddress1 = aNearestStores[i].ADDRESS1 != null ? aNearestStores[i].ADDRESS1 : '';		
			 	 sStreetAddress2 = aNearestStores[i].ADDRESS2 != null ? aNearestStores[i].ADDRESS2 : '';		
			 	 sStoreName = aNearestStores[i].DSNAME != null ? aNearestStores[i].DSNAME : '';					
			 	 sCity = aNearestStores[i].CITY != null ? aNearestStores[i].CITY : '';							
			 	 sState = aNearestStores[i].STATE != null ? aNearestStores[i].STATE : '';						
			 	 sZipCode = aNearestStores[i].ZIPCODE != null ? aNearestStores[i].ZIPCODE : '';					
			 	 sPhone = aNearestStores[i].PHONE != null ? aNearestStores[i].PHONE : '';						
			 	 sBopusEnabled = aNearestStores[i].BOPUS != null ? aNearestStores[i].BOPUS : '';                 
			 	 sAvailability = _oInStoreInventoryData[aNearestStores[i].STLOC_ID];
			 	 if(i == (aNearestStores.length - 1)){
			 		_nLastStoreDistance = aNearestStores[i].DISTANCE != null ? aNearestStores[i].DISTANCE : ''; 
			 	 }

			 	 if(sBopusEnabled == 'Y'){
				 	 if(sAvailability == 'GREEN'){
				 		 sCSSClass = 'remaining text-bold text-center';
				 		 sAvailability = 'Available';
				 	 } else if(sAvailability == 'YELLOW'){
				 		 sCSSClass = 'text-notice text-bold text-center';
				 		 sAvailability = 'Low Inventory';
				 	 } else {
				 		 sCSSClass = 'text-danger text-bold text-center';
				 		 sAvailability = 'Not Available';
				 	 }
			 	 }
			 	 else{
			 		 sCSSClass = 'text-bold text-center';
			 		 sAvailability = 'Pickup Currently Unavailable';
			 	 }


			 	 if(sStoreName.indexOf('Unleashed') != -1){
			 		sStoreName = sStoreName.substring(0,sStoreName.indexOf('Unleashed')-2);
			 	 }
				 if(aNearestStores[i].isPreferred == 'Y'){
					 sStoreName = sStoreName + "<span class='icon-stores-dark'></span><span class='mystoreIndicator text-normal text-x-small'>My Store</span>"
				 }
				 if(sStreetAddress2 != null && sStreetAddress2 != ''){
					 sFullStreetAddress = sStreetAddress1 + ' ' + sStreetAddress2;
				 }else{
					 sFullStreetAddress = sStreetAddress1;
				 }

				 				 if(oPhysicalStoreHours.hasOwnProperty(aNearestStores[i].IDENTIFIER)){
					 switch (new Date().getDay()) {
					 	case 0:
					    	if(oPhysicalStoreHours[aNearestStores[i].IDENTIFIER].T7CLOSE == '00:00:00'){
					    		sStoreOpenUntil = 'Closed';
					    	}else{
					    		if(fnIsStoreClosed(oPhysicalStoreHours[aNearestStores[i].IDENTIFIER].T7OPEN, oPhysicalStoreHours[aNearestStores[i].IDENTIFIER].T7CLOSE)){
					    			sStoreOpenUntil = 'Opens at ' + fnToDateTimeFormat(oPhysicalStoreHours[aNearestStores[i].IDENTIFIER].T1OPEN.substring(0,oPhysicalStoreHours[aNearestStores[i].IDENTIFIER].T1OPEN.lastIndexOf(":")));
					    		}else{
					    			sStoreOpenUntil = 'Open until ' + fnToDateTimeFormat(oPhysicalStoreHours[aNearestStores[i].IDENTIFIER].T7CLOSE.substring(0,oPhysicalStoreHours[aNearestStores[i].IDENTIFIER].T7CLOSE.lastIndexOf(":")));
					    		}
					    	}
					        break;
					    case 1:
					    	if(oPhysicalStoreHours[aNearestStores[i].IDENTIFIER].T1CLOSE == '00:00:00'){
					    		sStoreOpenUntil = 'Closed';
					    	}else{
					    		if(fnIsStoreClosed(oPhysicalStoreHours[aNearestStores[i].IDENTIFIER].T1OPEN, oPhysicalStoreHours[aNearestStores[i].IDENTIFIER].T1CLOSE)){
					    			sStoreOpenUntil = 'Opens at ' + fnToDateTimeFormat(oPhysicalStoreHours[aNearestStores[i].IDENTIFIER].T2OPEN.substring(0,oPhysicalStoreHours[aNearestStores[i].IDENTIFIER].T2OPEN.lastIndexOf(":")));
					    		}else{
					    			sStoreOpenUntil = 'Open until ' + fnToDateTimeFormat(oPhysicalStoreHours[aNearestStores[i].IDENTIFIER].T1CLOSE.substring(0,oPhysicalStoreHours[aNearestStores[i].IDENTIFIER].T1CLOSE.lastIndexOf(":")));
					    		}
					    	}
					        break;
					    case 2:
					    	if(oPhysicalStoreHours[aNearestStores[i].IDENTIFIER].T2CLOSE == '00:00:00'){
					    		sStoreOpenUntil = 'Closed';
					    	}else{
					    		if(fnIsStoreClosed(oPhysicalStoreHours[aNearestStores[i].IDENTIFIER].T2OPEN, oPhysicalStoreHours[aNearestStores[i].IDENTIFIER].T2CLOSE)){
					    			sStoreOpenUntil = 'Opens at ' + fnToDateTimeFormat(oPhysicalStoreHours[aNearestStores[i].IDENTIFIER].T3OPEN.substring(0,oPhysicalStoreHours[aNearestStores[i].IDENTIFIER].T3OPEN.lastIndexOf(":")));
					    		}else{
					    			sStoreOpenUntil = 'Open until ' + fnToDateTimeFormat(oPhysicalStoreHours[aNearestStores[i].IDENTIFIER].T2CLOSE.substring(0,oPhysicalStoreHours[aNearestStores[i].IDENTIFIER].T2CLOSE.lastIndexOf(":")));
					    		}
					    	}
					        break;
					    case 3:
					    	if(oPhysicalStoreHours[aNearestStores[i].IDENTIFIER].T3CLOSE == '00:00:00'){
					    		sStoreOpenUntil = 'Closed';
					    	}else{
					    		if(fnIsStoreClosed(oPhysicalStoreHours[aNearestStores[i].IDENTIFIER].T3OPEN, oPhysicalStoreHours[aNearestStores[i].IDENTIFIER].T3CLOSE)){
					    			sStoreOpenUntil = 'Opens at ' + fnToDateTimeFormat(oPhysicalStoreHours[aNearestStores[i].IDENTIFIER].T4OPEN.substring(0,oPhysicalStoreHours[aNearestStores[i].IDENTIFIER].T4OPEN.lastIndexOf(":")));
					    		}else{
					    			sStoreOpenUntil = 'Open until ' + fnToDateTimeFormat(oPhysicalStoreHours[aNearestStores[i].IDENTIFIER].T3CLOSE.substring(0,oPhysicalStoreHours[aNearestStores[i].IDENTIFIER].T3CLOSE.lastIndexOf(":")));
					    		}
					    	}
					        break;
					    case 4:
					    	if(oPhysicalStoreHours[aNearestStores[i].IDENTIFIER].T4CLOSE == '00:00:00'){
					    		sStoreOpenUntil = 'Closed';
					    	}else{
					    		if(fnIsStoreClosed(oPhysicalStoreHours[aNearestStores[i].IDENTIFIER].T4OPEN, oPhysicalStoreHours[aNearestStores[i].IDENTIFIER].T4CLOSE)){
					    			sStoreOpenUntil = 'Opens at ' + fnToDateTimeFormat(oPhysicalStoreHours[aNearestStores[i].IDENTIFIER].T5OPEN.substring(0,oPhysicalStoreHours[aNearestStores[i].IDENTIFIER].T5OPEN.lastIndexOf(":")));
					    		}else{
					    			sStoreOpenUntil = 'Open until ' + fnToDateTimeFormat(oPhysicalStoreHours[aNearestStores[i].IDENTIFIER].T4CLOSE.substring(0,oPhysicalStoreHours[aNearestStores[i].IDENTIFIER].T4CLOSE.lastIndexOf(":")));
					    		}
				    		}
					        break;
					    case 5:
					    	if(oPhysicalStoreHours[aNearestStores[i].IDENTIFIER].T5CLOSE == '00:00:00'){
					    		sStoreOpenUntil = 'Closed';
					    	}else{
					    		if(fnIsStoreClosed(oPhysicalStoreHours[aNearestStores[i].IDENTIFIER].T5OPEN, oPhysicalStoreHours[aNearestStores[i].IDENTIFIER].T5CLOSE)){
					    			sStoreOpenUntil = 'Opens at ' + fnToDateTimeFormat(oPhysicalStoreHours[aNearestStores[i].IDENTIFIER].T6OPEN.substring(0,oPhysicalStoreHours[aNearestStores[i].IDENTIFIER].T6OPEN.lastIndexOf(":")));
					    		}else{
					    			sStoreOpenUntil = 'Open until ' + fnToDateTimeFormat(oPhysicalStoreHours[aNearestStores[i].IDENTIFIER].T5CLOSE.substring(0,oPhysicalStoreHours[aNearestStores[i].IDENTIFIER].T5CLOSE.lastIndexOf(":")));
					    		}
					    	}
					        break;
					    case 6:
					    	if(oPhysicalStoreHours[aNearestStores[i].IDENTIFIER].T6CLOSE == '00:00:00'){
					    		sStoreOpenUntil = 'Closed';
					    	}else{
					    		if(fnIsStoreClosed(oPhysicalStoreHours[aNearestStores[i].IDENTIFIER].T6OPEN, oPhysicalStoreHours[aNearestStores[i].IDENTIFIER].T6CLOSE)){
					    			sStoreOpenUntil = 'Opens at ' + fnToDateTimeFormat(oPhysicalStoreHours[aNearestStores[i].IDENTIFIER].T7OPEN.substring(0,oPhysicalStoreHours[aNearestStores[i].IDENTIFIER].T7OPEN.lastIndexOf(":")));
					    		}else{
					    			sStoreOpenUntil = 'Open until ' + fnToDateTimeFormat(oPhysicalStoreHours[aNearestStores[i].IDENTIFIER].T6CLOSE.substring(0,oPhysicalStoreHours[aNearestStores[i].IDENTIFIER].T6CLOSE.lastIndexOf(":")));				 
					    		}
					    	}
					}						

					 					 	if(oPhysicalStoreHours[aNearestStores[i].IDENTIFIER].T1OPEN == '00:00:00' && oPhysicalStoreHours[aNearestStores[i].IDENTIFIER].T1CLOSE == '00:00:00'){

							sStoreHoursContent = '<strong>Mon</strong><span>Closed</span><br/>';
						}else{
							sStoreHoursContent = '<strong>Mon</strong><span>'+ fnToDateTimeFormat(oPhysicalStoreHours[aNearestStores[i].IDENTIFIER].T1OPEN.substring(0,oPhysicalStoreHours[aNearestStores[i].IDENTIFIER].T1OPEN.lastIndexOf(":"))) +' - ' + fnToDateTimeFormat(oPhysicalStoreHours[aNearestStores[i].IDENTIFIER].T1CLOSE.substring(0,oPhysicalStoreHours[aNearestStores[i].IDENTIFIER].T1CLOSE.lastIndexOf(":"))) + '</span><br/>';
						}

												if(oPhysicalStoreHours[aNearestStores[i].IDENTIFIER].T2OPEN == '00:00:00' && oPhysicalStoreHours[aNearestStores[i].IDENTIFIER].T2CLOSE == '00:00:00'){
							sStoreHoursContent += '<strong>Tue</strong><span>Closed</span><br/>';
						}else{
							sStoreHoursContent += '<strong>Tue</strong><span>'+ fnToDateTimeFormat(oPhysicalStoreHours[aNearestStores[i].IDENTIFIER].T2OPEN.substring(0,oPhysicalStoreHours[aNearestStores[i].IDENTIFIER].T2OPEN.lastIndexOf(":"))) +' - ' + fnToDateTimeFormat(oPhysicalStoreHours[aNearestStores[i].IDENTIFIER].T2CLOSE.substring(0,oPhysicalStoreHours[aNearestStores[i].IDENTIFIER].T2CLOSE.lastIndexOf(":"))) + '</span><br/>';
						}

												if(oPhysicalStoreHours[aNearestStores[i].IDENTIFIER].T3OPEN == '00:00:00' && oPhysicalStoreHours[aNearestStores[i].IDENTIFIER].T3CLOSE == '00:00:00'){
							sStoreHoursContent += '<strong>Wed</strong><span>Closed</span><br/>';
						}else{
							sStoreHoursContent += '<strong>Wed</strong><span>'+ fnToDateTimeFormat(oPhysicalStoreHours[aNearestStores[i].IDENTIFIER].T3OPEN.substring(0,oPhysicalStoreHours[aNearestStores[i].IDENTIFIER].T3OPEN.lastIndexOf(":"))) +' - ' + fnToDateTimeFormat(oPhysicalStoreHours[aNearestStores[i].IDENTIFIER].T3CLOSE.substring(0,oPhysicalStoreHours[aNearestStores[i].IDENTIFIER].T3CLOSE.lastIndexOf(":"))) + '</span><br/>';
						}

												if(oPhysicalStoreHours[aNearestStores[i].IDENTIFIER].T4OPEN == '00:00:00' && oPhysicalStoreHours[aNearestStores[i].IDENTIFIER].T4CLOSE == '00:00:00'){
							sStoreHoursContent += '<strong>Thu</strong><span>Closed</span><br/>';
						}else{
							sStoreHoursContent += '<strong>Thu</strong><span>'+ fnToDateTimeFormat(oPhysicalStoreHours[aNearestStores[i].IDENTIFIER].T4OPEN.substring(0,oPhysicalStoreHours[aNearestStores[i].IDENTIFIER].T4OPEN.lastIndexOf(":"))) +' - ' + fnToDateTimeFormat(oPhysicalStoreHours[aNearestStores[i].IDENTIFIER].T4CLOSE.substring(0,oPhysicalStoreHours[aNearestStores[i].IDENTIFIER].T4CLOSE.lastIndexOf(":"))) + '</span><br/>';
						}

												if(oPhysicalStoreHours[aNearestStores[i].IDENTIFIER].T5OPEN == '00:00:00' && oPhysicalStoreHours[aNearestStores[i].IDENTIFIER].T5CLOSE == '00:00:00'){
							sStoreHoursContent += '<strong>Fri</strong><span>Closed</span><br/>';
						}else{
							sStoreHoursContent += '<strong>Fri</strong><span>'+ fnToDateTimeFormat(oPhysicalStoreHours[aNearestStores[i].IDENTIFIER].T5OPEN.substring(0,oPhysicalStoreHours[aNearestStores[i].IDENTIFIER].T5OPEN.lastIndexOf(":"))) +' - ' + fnToDateTimeFormat(oPhysicalStoreHours[aNearestStores[i].IDENTIFIER].T5CLOSE.substring(0,oPhysicalStoreHours[aNearestStores[i].IDENTIFIER].T5CLOSE.lastIndexOf(":"))) + '</span><br/>';
						}

												if(oPhysicalStoreHours[aNearestStores[i].IDENTIFIER].T6OPEN == '00:00:00' && oPhysicalStoreHours[aNearestStores[i].IDENTIFIER].T6CLOSE == '00:00:00'){
							sStoreHoursContent += '<strong>Sat</strong><span>Closed</span><br/>';
						}else{
							sStoreHoursContent += '<strong>Sat</strong><span>'+ fnToDateTimeFormat(oPhysicalStoreHours[aNearestStores[i].IDENTIFIER].T6OPEN.substring(0,oPhysicalStoreHours[aNearestStores[i].IDENTIFIER].T6OPEN.lastIndexOf(":"))) +' - ' + fnToDateTimeFormat(oPhysicalStoreHours[aNearestStores[i].IDENTIFIER].T6CLOSE.substring(0,oPhysicalStoreHours[aNearestStores[i].IDENTIFIER].T6CLOSE.lastIndexOf(":"))) + '</span><br/>';
						}

												if(oPhysicalStoreHours[aNearestStores[i].IDENTIFIER].T7OPEN == '00:00:00' && oPhysicalStoreHours[aNearestStores[i].IDENTIFIER].T7CLOSE == '00:00:00'){
							sStoreHoursContent += '<strong>Sun</strong><span>Closed</span>';
						}else{
							sStoreHoursContent += '<strong>Sun</strong><span>'+ fnToDateTimeFormat(oPhysicalStoreHours[aNearestStores[i].IDENTIFIER].T7OPEN.substring(0,oPhysicalStoreHours[aNearestStores[i].IDENTIFIER].T7OPEN.lastIndexOf(":"))) +' - ' + fnToDateTimeFormat(oPhysicalStoreHours[aNearestStores[i].IDENTIFIER].T7CLOSE.substring(0,oPhysicalStoreHours[aNearestStores[i].IDENTIFIER].T7CLOSE.lastIndexOf(":"))) + '</span>';
						}

											}
				 if(sAvailability != 'Available'){
					 sStoreHTML = '<div class="row border-top-thin row-set"><div class="mobile-second-col"><div class="store-locator-modal-availability-mobile"><p class="'+sCSSClass+'">'+sAvailability+'</p></div><div class="store-locator-modal-distance-mobile"><p>' + nDistance + 'mi</p></div></div><div class="col-6 col-9-sm left-column-modal"><div class="col-3"><div class="store-locator-modal-logo"><img alt="'+ $.trim(sStoreType) +'" src="' + sImgSrc +'" ></div></div><div class="col-7"><div class="store-locator-modal-address"><p class="text-bold">'+ sStoreName +'</p><p>'+ sFullStreetAddress +'</p><p>' + sCity + ', ' + sState + ' ' +  sZipCode + '</p><a href="tel:'+sPhone+'">'+sPhone+'</a></div></div><div class="col-2"><div class="store-locator-modal-distance-desktop"><p>'+ nDistance + 'mi</p></div></div></div><div class="col-6 right-column-modal"><div class="col-3"><div class="store-locator-modal-availability-desktop"><p class="'+sCSSClass+'">'+sAvailability+'</p></div></div><div class="col-4"><p class="store-hours-message">'+sStoreOpenUntil+'<br/><a href="#" data-placement="top" data-toggle="popover" data-trigger="click" data-content="'+sStoreHoursContent+'">Store Hours</a></p></div><div class="col-5"><div class="store-locator-modal-pickup-btn"><button tabindex="0" class="btn-primary disabled"  onclick="return false">'+MessageHelper.messages["STORE_LOCATOR_MODAL_STORE_BUTTON"]+'</button></div></div></div></div>';				 
				 }else{
					 sStoreHTML = '<div class="row border-top-thin row-set"><div class="mobile-second-col"><div class="store-locator-modal-availability-mobile"><p class="'+sCSSClass+'">'+sAvailability+'</p></div><div class="store-locator-modal-distance-mobile"><p>' + nDistance + 'mi</p></div></div><div class="col-6 col-9-sm left-column-modal"><div class="col-3"><div class="store-locator-modal-logo"><img alt="'+ $.trim(sStoreType) +'" src="' + sImgSrc +'" ></div></div><div class="col-7"><div class="store-locator-modal-address"><p class="text-bold">'+ sStoreName +'</p><p>'+ sFullStreetAddress +'</p><p>' + sCity + ', ' + sState + ' ' +  sZipCode + '</p><a href="tel:'+sPhone+'">'+sPhone+'</a></div></div><div class="col-2"><div class="store-locator-modal-distance-desktop"><p>'+ nDistance + 'mi</p></div></div></div><div class="col-6 right-column-modal"><div class="col-3"><div class="store-locator-modal-availability-desktop text-center"><p class="'+sCSSClass+'">'+sAvailability+'</p></div></div><div class="col-4"><p class="store-hours-message">'+sStoreOpenUntil+'<br/><a href="#" data-placement="top" data-toggle="popover" data-trigger="click" data-content="'+sStoreHoursContent+'">Store Hours</a></p></div><div class="col-5"><div class="store-locator-modal-pickup-btn"><button tabindex="0" class="btn-primary" onclick="petcoNearestLocations.fnSelectStore('+'\''+aNearestStores[i].IDENTIFIER+'\''+',\'' +sAvailability+'\''+')">'+MessageHelper.messages["STORE_LOCATOR_MODAL_STORE_BUTTON"]+'</button></div></div></div></div>';				 
				 }
				 $('#petco-store-locator-modal').append(sStoreHTML);
				  $('#load-more-button').removeClass('disabled').addClass('btn-primary').attr('onclick','petcoNearestLocations.fnGetMoreStores();return false;');
				  $('#load-more-button').removeAttr("disabled", "disabled");
				 $('#load-more-button').show();
				 $('#no-more-stores').hide();

							 }
			 try{
	    		 for(i=0;i < aNearestStores.length;i++){
	    			 aStoreIdentifier.push(aNearestStores[i].IDENTIFIER);
	    		 }
	    		 oStoreEventJSON["physical_store_id"] = aStoreIdentifier;
	    		 oStoreEventJSON["event_name"] = 'store_modal_search';

	    			    		 pushEvent(oStoreEventJSON);

			    				 }catch(err){
				 return true;
			 }
			 fnHideXHRLoader();
		 }else{
			 $('#petco-store-locator-modal').append('<div id="store-locator-error-message" class="col-8 error-box">' + MessageHelper.messages["STORE_LOCATOR_MODAL_ERROR"] + '</div>');
			  $('#load-more-button').removeClass('disabled').addClass('btn-primary').attr('onclick','petcoNearestLocations.fnGetMoreStores();return false;');
			  $('#load-more-button').removeAttr("disabled", "disabled");
			 $('#load-more-button').hide();
			 $('#no-more-stores').hide();
			 console.debug('Empty array - aNearestStores: ' + aNearestStores);
		 }
	     if(_bIsDebuggingEnabled){
	    	console.debug('Debugging:: Exiting fnBuildModalUI(storeData).');
	     }
	 }

	 	 function fnOpenStoreInfoModal(){
		 if(_bIsDebuggingEnabled){
			 console.debug('Debugging:: Entering fnOpenStoreInfoModal().');
		 }
		 try{
			petcoCommonJS.showModal('neareststores');
			_changeStoreModalClick = true;
			try{
    			var oStoreModalEvent = {};
    			oStoreModalEvent["event_name"] = "store_modal_open";
    			pushEvent(oStoreModalEvent,'changeStore');

	    					}catch(err){
				console.log('An error occurred in creating the event store_modal_open. ' + err);
				return true;
			}

			$('#store-locator-zipcode').val('');
			_sZipCode =  document.getElementById('storeZipCode') != null ? $('#storeZipCode').val() : '';
			 if(_sZipCode != ''){
				 if(_sZipCode.indexOf('-') != -1){
					 _sZipCode = _sZipCode.substring(0,_sZipCode.indexOf('-'));
				 }
				fnShowXHRLoader();
				_nLastStoreDistance = '';
				fnGetData(ZIPCODE_API);
			 }
		 }catch(err){
			 fnHideXHRLoader();
			 console.log('An error occured in fnOpenStoreInfoModal(). '+err);
		 }
		 if(_bIsDebuggingEnabled){
			 console.debug('Exiting:: Entering fnOpenStoreInfoModal().');
		 }
	 }

		 		 function fnCloseStoreInfoModal(){
			 if(_bIsDebuggingEnabled){
				 console.debug('Debugging:: Entering fnCloseStoreInfoModal().');
			 }
			 try{
				 var modalRows = $('.row-set');
				 document.getElementById('store-locator-zipcode').value = '';
				 $('#load-more-button').removeClass('disabled').addClass('btn-primary').attr('onclick','petcoNearestLocations.fnGetMoreStores();return false;');
				 $('#load-more-button').removeAttr("disabled", "disabled");
				 $('#no-more-stores').hide();
				 if($(modalRows[0]).is(':visible')){
						$(modalRows).each(function(){
							$(this).remove();
						});
					}
				 if($('#store-locator-error-message').is(':visible')){
					 $('#store-locator-error-message').remove();
				 }
				 $('#store-locator-zipcode').removeClass('invalid');
				 $('#store-locator-zipcode-error').html('');

				 petcoCommonJS.hideModal('modal-neareststores');


				 				 			 }catch(err){
				 console.log('An error occured in fnCloseStoreInfoModal(). '+err);
			 }
			 if(_bIsDebuggingEnabled){
				 console.debug('Exiting:: Entering fnCloseStoreInfoModal().');
			 }
		 }	 

	 	 function fnGetNearestStoresByZipCode(){

		 		 if(_bIsDebuggingEnabled){
			 console.debug('Debugging:: Entering fnGetNearestStoresByZipCode().');
		 }
		 if($('#store-locator-error-message').is(':visible')){
			 $('#store-locator-error-message').remove();
		 }
		 _nLastStoreDistance = '';
		 _sZipCode = (document.getElementById('store-locator-zipcode')!= null &&  document.getElementById('store-locator-zipcode') != undefined) ? document.getElementById('store-locator-zipcode').value : '';

		 		 _sZipCode = $.trim(_sZipCode);

		 		 _showPreferredStore = false;

		 		 var errorMessageHTML = '<span class="error">'+ MessageHelper.messages["SHIPPING_ADDRESS_VALID_ZIP_CODE"] + '</span>';

		 if(_sZipCode == ''){
			 $('#store-locator-zipcode').addClass('invalid');
			 $('#store-locator-zipcode-error').html(errorMessageHTML);
			 return false;
		 }else if(_sZipCode.length < 5 || _sZipCode.length > 5){
			 $('#store-locator-zipcode').addClass('invalid');
			 $('#store-locator-zipcode-error').html(errorMessageHTML);
			 return false;
		 }else if(!$.isNumeric(parseInt(_sZipCode))){
			 $('#store-locator-zipcode').addClass('invalid');
			 $('#store-locator-zipcode-error').html(errorMessageHTML);
			 return false;
		 }else{
			 $('#store-locator-zipcode').removeClass('invalid');
			 $('#store-locator-zipcode-error').html('');
			 fnShowXHRLoader();
			 fnGetData(ZIPCODE_API);
		 }
		 if(_bIsDebuggingEnabled){
			 console.debug('Debugging:: Exiting fnGetNearestStoresByZipCode().');
		 }
	 }


	 	 function fnZIPCodeData(preferedStorReq){
		 if(_bIsDebuggingEnabled){
			 console.debug('Debugging:: Entering fnZIPCodeData().');
		 }
		 var oJSONData = {},
		 	 aSkuListArray = [],
		 	 skuListId = document.getElementById('skuList'),
		 	 sProductIds = '';

		 		 if(skuListId != null && skuListId != undefined){
			 aSkuListArray = JSON.parse(skuListId.value);
			 if(aSkuListArray.length > 0){
				 for(i=0;i<aSkuListArray.length;i++){
					 sProductIds += aSkuListArray[i] + (i != (aSkuListArray.length -1) ? ',' : '');
				 }
			 }
		 }

		 oJSONData['zipCode'] = _sZipCode;

		 		 if(typeof(preferedStorReq) != "undefined" ){
			 oJSONData['showPreferredStore'] = preferedStorReq;
		 }else{
		 oJSONData['showPreferredStore'] = fnGetPreferedStoreData();
		 }

		 if(sProductIds != '' && sProductIds != null){
			 oJSONData['productIds'] = sProductIds
		 }
		 if(_nLastStoreDistance != '' && _nLastStoreDistance != null){
			 oJSONData['distance'] = _nLastStoreDistance;
		 }
		 if(_bIsDebuggingEnabled){
			 console.debug('Debugging:: oJSONData - ' + JSON.stringify(oJSONData));
			 console.debug('Debugging:: Exiting fnZIPCodeData().');
		 }
		 return oJSONData;
	 }
	 function fnGetPreferedStoreData(){
		 var status = false;
		 var preferedStore = "";
		 var DSNAME = "";
		 var oStores = JSON.parse(localStorage.getItem(LOCALSTORAGE_STORES_KEY));
		 var oPetcostores = oStores.petcostores;
		 if(typeof(oPetcostores) != "undefined"){
			 var storeVal = JSON.parse(oPetcostores);

							 if(storeVal.length > 1){
				 	for(var i=0;i<storeVal.length;i++){
				  		if( typeof(storeVal[i].isPreferred)!= "undefined" && storeVal[i].isPreferred == "Y"){
					 	status = true;
						break;
						}
					}
				 }else if(storeVal.length == 1 && typeof(storeVal.isPreferred)!= "undefined" && storeVal.isPreferred == "Y"){
					 status= true; 
				 }
		 }

		 		 return status;
	 }


	 	 function fnSelectStore(storeIdentifier,availability){
		 if(_bIsDebuggingEnabled){
			 console.debug('Debugging:: Entering fnSelectStore(positionInArray).');
		 }
		 if(typeof(productDisplayJS) != "undefined"){
			 productDisplayJS.bopusInventoryDetailsPopulated = false;
		 }



				 		 		 var oRecord = {},
	 	 	 nExpirationMS = _nExpirationMin * 60 * 1000,
	 	 	 oNearestStores = {},
	 	 	 aNearestStores = [];

					 _showPreferredStore = false;
		 fnLatitudeLongitudeSetLocalStorage(_userData.LATITUDE,_userData.LONGITUDE)
		 if(parseInt(_nExpirationMin) > 0){
			 oRecord = {"petcostores":JSON.stringify(fnShiftArray(_tempStoreData,findIndexByKeyValue(_tempStoreData,'IDENTIFIER',storeIdentifier),0)),"storehours":JSON.stringify(_oStoreHours) ,"shipmodes":JSON.stringify(_shipmodedetails),"userDetails":JSON.stringify(_userData), "timestamp": _timestamp + nExpirationMS};
		 }else{
			 oRecord = {"petcostores":JSON.stringify(fnShiftArray(_tempStoreData,findIndexByKeyValue(_tempStoreData,'IDENTIFIER',storeIdentifier),0)), "storehours":JSON.stringify(_oStoreHours),"shipmodes":JSON.stringify(_shipmodedetails),"userDetails":JSON.stringify(_userData), "timestamp":0};
		 }
		 localStorage.setItem(LOCALSTORAGE_STORES_KEY, JSON.stringify(oRecord));

		 oNearestStores = JSON.parse(localStorage.getItem(LOCALSTORAGE_STORES_KEY));

		 		 if(Object.keys(oNearestStores).length > 0){
			 aNearestStores = JSON.parse(oNearestStores.petcostores);
			 fnSetPhysicalStoreCookie('WC_physicalStores', aNearestStores);
			 if(typeof(window._updateUserStore) === 'function'){
			  _store_got_Changed = true;
			  localStorage.removeItem("USER_SET_PREFERRED_STORE_NAME");
			  localStorage.removeItem("USER_SET_PREFERRED_STORE_LOCATION_ID");
			  localStorage.removeItem("USER_SET_PREFERRED_STORE_ID");

				 					window._updateUserStore({
					  id: aNearestStores[0].IDENTIFIER,
					  locationId: aNearestStores[0].STLOC_ID,
					  name: aNearestStores[0].DSNAME
					})

									}
			 _populate_Service_location();
			 dojo.topic.publish('changeStlocIdForCheckout', aNearestStores[0]["STLOC_ID"]);
		 };


		 					 try{
    			var oStoreModalEvent = {};
    			oStoreModalEvent["physical_store_id"] = storeIdentifier;
    			oStoreModalEvent["event_name"] = 'store_modal_changed_store';
    			pushEvent(oStoreModalEvent);
			}catch(err){
				console.log('An error occurred in creating the event store_modal_changed_store. ' + err);
				return true;
			}


		 fnBuildStoreInfoUI(aNearestStores,availability);
		 _nLastStoreDistance = '';


				 		 if(_bIsDebuggingEnabled){
			 console.debug('Debugging:: Exiting fnSelectStore(positionInArray).');
		 }
	 }


	 	 function fnUpdateBopusHeader(){
		 var oNearestStores = {},
 	 	 aNearestStores = [],
 	 	 ostoreHours = {},
		 oNearestStores = JSON.parse(localStorage.getItem(LOCALSTORAGE_STORES_KEY));
		 if(oNearestStores != undefined && oNearestStores != null && Object.keys(oNearestStores).length > 0 ){
			 aNearestStores = JSON.parse(oNearestStores.petcostores);
			 ostoreHours = JSON.parse(oNearestStores.storehours);
			 var identifier = aNearestStores[0].IDENTIFIER;
			 if(Object.keys(ostoreHours).length > 0 && identifier != null)
			 switch (CheckoutHelperJS.presentDate.getDay()) {
			 	case 0:
			 		if(ostoreHours[identifier].T7OPEN != '00:00:00' && ostoreHours[identifier].T7CLOSE != '00:00:00')
			 		{
			 			CheckoutHelperJS.checkStoreHours(ostoreHours[identifier].T7CLOSE,CheckoutHelperJS.presentDate.getDay());
			 		}
			 		break;
			 	case 1:
			 		if(ostoreHours[identifier].T1OPEN != '00:00:00' && ostoreHours[identifier].T1CLOSE != '00:00:00')
			 		{
			 			CheckoutHelperJS.checkStoreHours(ostoreHours[identifier].T1CLOSE,CheckoutHelperJS.presentDate.getDay());
			 		}
			 		break;
			 	case 2:
			 		if(ostoreHours[identifier].T2OPEN != '00:00:00' && ostoreHours[identifier].T2CLOSE != '00:00:00')
			 		{
			 			CheckoutHelperJS.checkStoreHours(ostoreHours[identifier].T2CLOSE,CheckoutHelperJS.presentDate.getDay());
			 		}
			 		break;
			 	case 3:
			 		if(ostoreHours[identifier].T3OPEN != '00:00:00' && ostoreHours[identifier].T3CLOSE != '00:00:00')
			 		{
			 			CheckoutHelperJS.checkStoreHours(ostoreHours[identifier].T3CLOSE,CheckoutHelperJS.presentDate.getDay());
			 		}
			 		break;
			 	case 4:
			 		if(ostoreHours[identifier].T4OPEN != '00:00:00' && ostoreHours[identifier].T4CLOSE != '00:00:00')
			 		{
			 			CheckoutHelperJS.checkStoreHours(ostoreHours[identifier].T4CLOSE,CheckoutHelperJS.presentDate.getDay());
			 		}
			 		break;
			 	case 5:
			 		if(ostoreHours[identifier].T5OPEN != '00:00:00' && ostoreHours[identifier].T5CLOSE != '00:00:00')
			 		{
			 			CheckoutHelperJS.checkStoreHours(ostoreHours[identifier].T5CLOSE,CheckoutHelperJS.presentDate.getDay());
			 		}
			 		break;
			 	case 6:
			 		if(ostoreHours[identifier].T6OPEN != '00:00:00' && ostoreHours[identifier].T6CLOSE != '00:00:00')
			 		{
			 			CheckoutHelperJS.checkStoreHours(ostoreHours[identifier].T6CLOSE,CheckoutHelperJS.presentDate.getDay());
			 		}
			 		break;
		 };
			 }
	 }

	 	 function fnShiftArray(array, old_index, new_index) {
		 if(_bIsDebuggingEnabled){
			 console.debug('Debugging:: Entering fnShiftArray(array, old_index, new_index).');
			 console.debug('Debugging:: array - ' + array);
			 console.debug('Debugging:: old_index - ' + old_index);
			 console.debug('Debugging:: new_index - ' + new_index);
		 }
	    while (old_index < 0) {
	        old_index += array.length;
	    }
	    while (new_index < 0) {
	        new_index += array.length;
	    }
	    if (new_index >= array.length) {
	        var k = new_index - array.length;
	        while ((k--) + 1) {
	        	array.push(undefined);
	        }
	    }
	    array.splice(new_index, 0, array.splice(old_index, 1)[0]);

	    	    if(_bIsDebuggingEnabled){
	    	console.debug('Debugging:: array - '+array);
			console.debug('Debugging:: Exiting fnShiftArray(array, old_index, new_index).');
		}

	    	   return array;
	 }


	 	 function fnGetSortOrder(key) {  
	    return function(a, b) {  
	        if (a[key] > b[key]) {  
	            return 1;  
	        } else if (a[key] < b[key]) {  
	            return -1;  
	        }  
	        return 0;  
	    }  
	}

	 	 function findIndexByKeyValue(obj, key, value)
	 {
	     for (var i = 0; i < obj.length; i++) {
	         if (obj[i][key] == value) {
	             return i;
	         }
	     }
	     return null;
	 }


	 	 function fnShowXHRLoader(){
		 $('#store-loader').css({
			 'position': 'absolute',
			 'top': '50%',
			 'left': '48%',
			 'z-index': '1001'
			}).show();

		 		 $('#background-loader').css({
			 'position': 'fixed',
			 'left': '0',
			 'top': '0',
			 'width': '100%',
			 'height': '300%',
			 'background-color': 'rgba(255,255,255,0.80)',
		  	 'z-index': '999'
		 }).show();



		 		 		    	 }

	 	 function fnHideXHRLoader(){
		 $('#store-loader').hide();
		 $('#background-loader').hide();
	 }
	 function fnGetInventory(sStoreLoc){
		 var aInStoreInventory,
	 	 catEntryIdList = document.getElementById('catEntryIdForBOPUSModal'),
	 	 catEntryId = '';

		 if(sStoreLoc != null && sStoreLoc != ''){
			 if(catEntryIdList != null && catEntryIdList != undefined){
				 if(catEntryIdList.value.indexOf(',') != -1){
					 catEntryId = catEntryIdList.value.split(',')[0];
				 }else{
					 catEntryId = catEntryIdList.value;
				 }
		 	}
			 productDisplayJS.storeId = _sStoreId;	

			 			 var inventorySystem = $('#inventorySystem').val();
			 if(inventorySystem != -4) {
				 var url = productDisplayJS.findYIHInvetoryAvailabilityURL(catEntryId,sStoreLoc);
					$.ajax({
						url : url,
						type : 'GET',
						contentType: 'application/json',
						dataType: 'json',
						data: '',
						cache: false,
						async: false,
						success: function(data){
							var inventoryData = {};		
							if(typeof(data.inStoreInventory) != 'undefined'){
								var storeInventoryDetails = data.inStoreInventory; 
				 				for(var j = 0 ; j < storeInventoryDetails.length ; j++){		 					
				 					var stlocId = storeInventoryDetails[j].stlocId;	
				 					inventoryData[stlocId] = storeInventoryDetails[j].alertLevel;
				 				}			 			
							}
							_oInStoreInventoryData = inventoryData;
						},
						error: function(error){
							console.log('An error occurred in fnGetInventory() while making a call to GetInventoryStatusByIDView. ' + error);
						}
					});
			 } else {
				 var params = new Object();
				 params.itemId = catEntryId;
				 params.langId = WCParamJS.langId;
				 params.storeId = WCParamJS.storeId;
				 params.catalogId = WCParamJS.catalogId;	
				 params.storeModal = true;
				 params.storeLoc = sStoreLoc;
				 params.fetchStoreInventory = true;
				 dojo.xhrPost({
						url: getAbsoluteURL() + "GetInventoryStatusByIDView",
						handleAs: "json-comment-filtered",
						content: params,
						service: this,
						timeout: 5000,
						sync : true,
						load: function(data){
							var inStoreInventory = [],
							inventoryData = {};			
							if(typeof(data.inStoreInventory) != 'undefined'){
								var storeInventoryDetails = data.inStoreInventory; 
								if(storeInventoryDetails.stores != null && storeInventoryDetails.stores != ''){
									inStoreInventory = storeInventoryDetails.stores;
									for(i=0; i < inStoreInventory.length;i++){
										var stlocId = inStoreInventory[i].id;	
					 					inventoryData[stlocId] = inStoreInventory[i].alertLevel;
									}
								}		
							}
							_oInStoreInventoryData = inventoryData;
						},
						error: function(errObj,ioArgs) {
							console.log(storeNLS["INV_STATUS_RETRIEVAL_ERROR"]);
						}
				});		 
			 }


								 }
	 }

	 function fnGetMoreStores(){
		 var modalRows = $('.row-set');

		 		 if(modalRows.length >= 20){
			 $('#load-more-button').addClass('disabled').removeClass('btn-primary').removeAttr('onclick');
			 $('#load-more-button').attr("disabled", "disabled");
		 	 $('#no-more-stores').show();
		 	 return false;
		 }else{
			 fnShowXHRLoader();
			 fnGetData(ZIPCODE_API,false);
		 }

		 	 }



	 	 function fnToDateTimeFormat(sTime) {
			var currentDate = new Date();
			currentDate.setHours(sTime.substr(0,sTime.indexOf(":")));
			currentDate.setMinutes(sTime.substr(sTime.indexOf(":")+1));
			currentDate.setSeconds(0);
	 		return currentDate.toLocaleTimeString([], {hour: '2-digit', minute:'2-digit'});

			}

	 function checkAndProcessUrlStoreParam(){
		 var urlParam = window.location.search.substring(1);
		 if( urlParam != "" ){
			 var urlParamArray = urlParam.split("&");
			 for( var i = 0 ; i < urlParamArray.length ; i++ ){
				 var urlParamArrayVal = urlParamArray[i].split("=");
				 if(urlParamArrayVal[0] == _storeCodeParameter && urlParamArrayVal[1].trim() != '' ){
					 _storePassedAsParam = urlParamArrayVal[1].trim();
					 localStorage.removeItem(LOCALSTORAGE_STORES_KEY);
					 fnCreateCookie('WC_physicalStores','',-100);
					 _sGoogleStoreCodePresent = true;
				 }
			 }
		 }
	 }

	 	 function  checkIfStoreStatusAndClearStorage(petcoStores){
		 if(ClosedStoreDetailsObj != null){
			 callClosedStoreDataFn(petcoStores,ClosedStoreDetailsObj);
			 return;
		 }
		 		$.ajax({
			 		url : getAbsoluteURL() + "ClosedStoreDetails?catalogId=10051&langId=-1&storeId=10151",
			 		type : 'GET',
			 		cache: false,
			 		contentType: 'application/json',
			 		dataType: 'json',
			 		data: '',
		 		success: function(data){
		 			IS_CLOSED_CALL_FIRED = false;
		 			ClosedStoreDetailsObj=data;
		 			 callClosedStoreDataFn(petcoStores,data);
		 		},
		 		error: function(error){
		 			console.log(error);
		 		}

		 	});
	 }
	 var IS_CLOSED_CALL_FIRED = false; 
	 function callClosedStoreDataFn(petcoStores,data){
		 if(IS_CLOSED_CALL_FIRED){
			 return;
		 }
			var shoulExpireeStorageCleared = true;
			var triggeredCall = false;
			for( var i = 0 ; i < petcoStores.length ; i++){
				for( var ix in data.closedStores){
	 				for( var j in data.closedStores[ix]){
		 				if( i == 0 && j == petcoStores[i].IDENTIFIER){
		 					localStorage.removeItem(LOCALSTORAGE_STORES_KEY);
		 					shoulExpireeStorageCleared = false;
		 					if($("#petcoNearestLocationsInitScript").length > 0  && !IS_CLOSED_CALL_FIRED){
		 						triggeredCall = true;
		 						IS_CLOSED_CALL_FIRED = true;
		 						eval($("#petcoNearestLocationsInitScript").html());
		 						break;
		 					}
		 				}
	 				}
	 				if(triggeredCall){
	 					break;
	 				}
	 			}
				if( i == 0 ){
					break;
				}
			}
			if(shoulExpireeStorageCleared){
				var mapFfromLocal = {};
				var isDataExistsForClosed=false;
				for( var iy in data.closedStores){
	 				for( var jx in data.closedStores[iy]){
	 					mapFfromLocal[jx]='true';	
	 					isDataExistsForClosed = true;
	 				}
	 			}
				var expiredStoresFromLocal = localStorage.getItem(EXPIR_STORE_DATA);
				if(expiredStoresFromLocal != null){
					var expiredStoresFromLocalJSONTmp = JSON.parse(expiredStoresFromLocal);
					if(expiredStoresFromLocalJSONTmp.closedStores.length == 0){
						localStorage.setItem(EXPIR_STORE_DATA, JSON.stringify(data));
						if(isDataExistsForClosed){
							if($("#petcoNearestLocationsInitScript").length > 0 && !IS_CLOSED_CALL_FIRED){
								IS_CLOSED_CALL_FIRED = true;
		 						eval($("#petcoNearestLocationsInitScript").html());
		 					}
							expiredStoresFromLocal = null;
						}
					}
				}


												if(expiredStoresFromLocal != null){
					var expiredStoresFromLocalJSON = JSON.parse(expiredStoresFromLocal);
					for( var ix in expiredStoresFromLocalJSON.closedStores){
						for( var j in expiredStoresFromLocalJSON.closedStores[ix]){
							if(typeof(mapFfromLocal[j]) == "undefined"){
								localStorage.removeItem(LOCALSTORAGE_STORES_KEY);
								if($("#petcoNearestLocationsInitScript").length > 0  && !IS_CLOSED_CALL_FIRED){
									IS_CLOSED_CALL_FIRED = true;
			 						eval($("#petcoNearestLocationsInitScript").html());
			 					}
			 					break;
							}
						}
					}
				}



														}

						localStorage.setItem(EXPIR_STORE_DATA, JSON.stringify(data));

		 	 }


	 function fnGetNearestLocations(storeId, expirationMin, isHTML5Geolocation, isGoogleGeoAPI, HTML5GeoTimeout, XHRTimeout, googleApiUrl, googleApiKey, isDebuggingEnabled){
		 if(_bIsDebuggingEnabled){
			 console.debug('Debugging:: fnGetNearestLocations(storeId, expirationMin, isHTML5Geolocation, isGoogleGeoAPI, HTML5GeoTimeout, XHRTimeout, googleApiUrl, googleApiKey, isDebuggingEnabled).');
			 console.debug('Debugging:: storeId - ' + storeId);
			 console.debug('Debugging:: expirationMin - ' + expirationMin);
			 console.debug('Debugging:: isHTML5Geolocation - ' + isHTML5Geolocation);
			 console.debug('Debugging:: isGoogleGeoAPI - ' + isGoogleGeoAPI);
			 console.debug('Debugging:: HTML5GeoTimeout - ' + HTML5GeoTimeout);
			 console.debug('Debugging:: XHRTimeout - ' + XHRTimeout);
			 console.debug('Debugging:: googleApiUrl - ' + googleApiUrl);
			 console.debug('Debugging:: googleApiKey - ' + googleApiKey);
			 console.debug('Debugging:: isDebuggingEnabled - ' + isDebuggingEnabled);
		 }

		 		var isEASession = dojo.cookie('isEASession');
		if (typeof(isEASession) != "undefined" && isEASession == "yes" ){
			return;
		}		
		if(window && typeof window.page != 'undefined' && typeof window.page.page_type != 'undefined' ){
			if(!(window.page.page_type =='Product' || window.page.page_type=='SubCategory' ||window.page.page_type=='Brand'|| window.page.page_type =='ShoppingCart' ||window.page.page_type =='Search' )){
				console.log("By passing the geolocation call");
				return;
			}
		}
		 try{
			 if(storeId != ''){
				 _sStoreId = storeId;
			 }

		 	if(expirationMin != ''){
		 		_nExpirationMin = parseInt(expirationMin);
		 	}

		 	if(isHTML5Geolocation != ''){
		 		_bIsHTML5Geolocation = (isHTML5Geolocation.toLowerCase() === 'true');
		 	}

		 	if(isGoogleGeoAPI != ''){
		 		_bIsGoogleGeoAPI = (isGoogleGeoAPI.toLowerCase() === 'true');
		 	}

		 	if(HTML5GeoTimeout != ''){
			 	_nHTML5GeoTimeout =  parseInt(HTML5GeoTimeout);
		 	}

		 	if(XHRTimeout != ''){
			 	_nXHRTimeout = parseInt(XHRTimeout);
		 	}

		 			 	if(googleApiUrl != ''){
		 		_sGoogleAPIUrl = googleApiUrl;
		 	}

		 			 	if(googleApiKey != ''){
		 		_sKey = googleApiKey;
		 	}

		 	if(isDebuggingEnabled != ''){
			 	_bIsDebuggingEnabled = (isDebuggingEnabled.toLowerCase() === 'true');
		 	}

		 			 	checkIfReactLocationIsDifferent(false);

		 			 	checkAndProcessUrlStoreParam();




		 			 			 			 	if(fnCheckLocalStorage()){		 		
		 		if(!fnCheckLocalStorageLatLong()){
		 			fnGeoLocationFromLatLongLocalStorage();
		 			_populate_Service_location();
		 		}else{
			 		fnGeoLocation();
		 		}
		 		var akamaiCountry= dojo.cookie("Edgescape-Country");
		 		if(typeof(akamaiCountry) != "undefined"  && akamaiCountry =="US"){		
		 		dojo.topic.subscribe('callCompletedforLocationCheck', function(val){
				setTimeout(function(){
		 			if(val!="AKAMAI"){
		 				if(fnCheckLocalStorage()){		 	
				 			var akamaiCookie = dojo.cookie("Edgescape-Zip");
				 			if(typeof(akamaiCookie) != "undefined" && akamaiCookie != "" && akamaiCookie != null){
				 				var fZipCodeRange=akamaiCookie.split('+');
				 				var fZipCode = fZipCodeRange[0].split('-');
				 				_akamaiZipCode=fZipCode[0];
								fnGetData(AKAMAI_ZIPCODE);
				 			}
				 		}
		 			}else{
		 				if(fnIsPDP() && fnIsBOPUSItem()){
		 					if(!_changeStoreModalClick){
		 						fnBuildStoreInfoUI();
		 					}else{
		 						_changeStoreModalClick = false;
		 					}

				 							 		}
		 			}


		 					 					 },2000)


		 			 		 });
		 		}
		 	}else{
		 		_populate_Service_location();
		 		dojo.topic.publish('BopusAreaRestrictionCheck', "FromLocalHost");
		 		if(fnIsPDP() && fnIsBOPUSItem()){
		 			fnBuildStoreInfoUI();
		 		}else{
			 		return;
		 		}

		 				 	}
		 }catch(err){
			 console.log('An error occurred in fnGetNearestLocations. ' + err);
			 return;
		 }


		 	 		 	if(_bIsDebuggingEnabled){
			 console.debug('Debugging:: Exiting fnGetNearestLocations(storeId, expirationMin, isHTML5Geolocation, isGoogleGeoAPI, isDebuggingEnabled).');
		 }

	 }	

		 		 function fnAkamaiZIPCodeData(){
			 if(_bIsDebuggingEnabled){
				 console.debug('Debugging:: Entering fnZIPCodeData().');
			 }
			 var oJSONData = {},
			 	 aSkuListArray = [],
			 	 skuListId = document.getElementById('skuList'),
			 	 sProductIds = '';

			 			 if(skuListId != null && skuListId != undefined){
				 aSkuListArray = JSON.parse(skuListId.value);
				 if(aSkuListArray.length > 0){
					 for(i=0;i<aSkuListArray.length;i++){
						 sProductIds += aSkuListArray[i] + (i != (aSkuListArray.length -1) ? ',' : '');
					 }
				 }
			 }

			 oJSONData['zipCode'] = _akamaiZipCode;
			 oJSONData['akamaiFlag'] = 'yes';
			 if(sProductIds != '' && sProductIds != null){
				 oJSONData['productIds'] = sProductIds
			 }
			 oJSONData['showPreferredStore'] = true;
			 if(_bIsDebuggingEnabled){
				 console.debug('Debugging:: oJSONData - ' + JSON.stringify(oJSONData));
				 console.debug('Debugging:: Exiting fnZIPCodeData().');
			 }
			 return oJSONData;
		 }
		 var IS_CHANGE_CALL_FROM_REACT_FIRED = false; 
		 function updateReactStoreChange(payLoad){
			 try{
				 	var params = [];
						 if(typeof(payLoad) != "undefined"){
							 var storeId = payLoad.id;
							 var headerStoreId = payLoad.locationId;
							 console.log("_storePassedAsParam"+storeId);
							 _storePassedAsParam = storeId;
							 localStorage.removeItem(LOCALSTORAGE_STORES_KEY);
							 IS_CHANGE_CALL_FROM_REACT_FIRED = false;
							 checkIfReactLocationIsDifferent(true);
							 if($('div[dojotype="wc.widget.RefreshArea"][controllerid^="ShopCartDisplayController"]').length > 0){
								 var isBopusOrder = $("#isBopusOrder").val();
								 var bopusPhysicalStoreSelected = $("#bopusPhysicalStoreSelected").val();
								 if(isBopusOrder == 'true'){
									 setTimeout(function(){
										 if(headerStoreId != bopusPhysicalStoreSelected){
											 params["physicalStoreId"] = headerStoreId;
											 params["orderId"] = $("#currentOrderId").val();
											 wc.service.invoke("AjaxUpdatePickUpStoreCmd",params);
										 }
									 },2000);
								 }else{
									 setTimeout(function(){	 
										 var loc = window.location.href,index = loc.indexOf('#');
											if (index > 0) {
												window.location = loc.substring(0, index);
											}else{
												window.location.reload(true);
											}
										 },2000);
								}
							}
						 }				 

					 }catch(err){
				 console.log(err);
			 }



			 			 			 		 }
		 function checkIfReactLocationIsDifferent(triggerNearestLocationsCall){	
			 console.log("IS_CHANGE_CALL_FROM_REACT_FIRED" >> IS_CHANGE_CALL_FROM_REACT_FIRED);
			 if(!IS_CHANGE_CALL_FROM_REACT_FIRED){

				 				 _populate_Service_location();
				 try{
					 var reactStoreId = localStorage.getItem("USER_SET_PREFERRED_STORE_ID");
					 var reactPhysicalStoreId = localStorage.getItem("USER_SET_PREFERRED_STORE_LOCATION_ID");
					 console.log("reactStoreId>>>>>>"+reactStoreId);
					 var oNeareststores = JSON.parse(localStorage.getItem(LOCALSTORAGE_STORES_KEY)) != null ? JSON.parse(localStorage.getItem(LOCALSTORAGE_STORES_KEY)) : {};
					 console.log("oNeareststores>>>>>>"+oNeareststores);
					 if((oNeareststores == null || 
						(oNeareststores != null &&  Object.keys(oNeareststores).length == 0 ) || 
						(oNeareststores != null &&  Object.keys(oNeareststores).length > 0  && typeof(oNeareststores.petcostores) == 'undefined')) &&
						reactStoreId != null  &&  !IS_CHANGE_CALL_FROM_REACT_FIRED){
						 IS_CHANGE_CALL_FROM_REACT_FIRED = true;
						 console.log("oNeareststores>>>>>>"+oNeareststores);
						 _storePassedAsParam = reactStoreId;
						 localStorage.removeItem(LOCALSTORAGE_STORES_KEY);
						 fnCreateCookie('WC_physicalStores','',-100);
						 if(triggerNearestLocationsCall && $("#petcoNearestLocationsInitScript").length > 0 ){

															eval($("#petcoNearestLocationsInitScript").html());
							}
					 }else if(reactStoreId != null && reactPhysicalStoreId != null && reactStoreId != "" && reactPhysicalStoreId != ""  && !IS_CHANGE_CALL_FROM_REACT_FIRED){
						   IS_CHANGE_CALL_FROM_REACT_FIRED = true; 
						 var isStoreSame = false;
						  var WC_physicalStores = decodeURIComponent(getCookie("WC_physicalStores")).split(",");
						  if(WC_physicalStores[0] != ""){
							  if(WC_physicalStores[0].trim() === reactPhysicalStoreId){
								  isStoreSame = true;
							  }
						  }
						   if(!isStoreSame){							
								 _storePassedAsParam = reactStoreId;
								 localStorage.removeItem(LOCALSTORAGE_STORES_KEY);
								 fnCreateCookie('WC_physicalStores','',-100);
								 if(triggerNearestLocationsCall && $("#petcoNearestLocationsInitScript").length > 0){

									 										eval($("#petcoNearestLocationsInitScript").html());
									}
						   }

						 					 }

					 				 }catch(err){
					 console.log(err);
				 }
				 if(!IS_CHANGE_CALL_FROM_REACT_FIRED){
					 IS_CHANGE_CALL_FROM_REACT_FIRED = true;
				 }
			 }

			 		 }
		 function fnOpenZipCodefoModal(){
			 if(_bIsDebuggingEnabled){
				 console.debug('Debugging:: Entering fnOpenZipCodefoModal().');
			 }
			 try{
				petcoCommonJS.showModal('zipcodeLocation');

				 $('#sameday-zipcode-error').html('');

						 }catch(err){
				 fnHideXHRLoader();
				 console.log('An error occured in fnOpenZipCodefoModal(). '+err);
			 }
			 if(_bIsDebuggingEnabled){
				 console.debug('Exiting:: Entering fnOpenZipCodefoModal().');
			 }
		 }
		 function updateZipcodeForSameday(catalogEntryID){

								_sZipCode = (document.getElementById('sameday-popup-zipcode')!= null &&  document.getElementById('sameday-popup-zipcode') != undefined) ? document.getElementById('sameday-popup-zipcode').value : '';

				 				 _sZipCode = $.trim(_sZipCode);

				 				 _showPreferredStore = false;

				 				 var errorMessageHTML = '<span class="error">'+ MessageHelper.messages["SHIPPING_ADDRESS_VALID_ZIP_CODE"] + '</span>';

				 if(_sZipCode == ''){
					 $('#sameday-zipcode-error').html(errorMessageHTML);
					 return false;
				 }else if(_sZipCode.length < 5 || _sZipCode.length > 5){
					 $('#sameday-zipcode-error').html(errorMessageHTML);
					 return false;
				 }else if(!$.isNumeric(_sZipCode)){
					 $('#sameday-zipcode-error').html(errorMessageHTML);
					 return false;
				 }else{ 
					 $('#sameday-zipcode-error').html('');
					 $('span[id="sameday-zipcode"]').html(_sZipCode);
						localStorage.setItem('obo_sameday_zipcode',_sZipCode)
					 if( catalogEntryID != null){
						 var resolvedcatalogEntryId = productDisplayJS.getCatalogEntryId("entitledItem_"+catalogEntryID);
						 productDisplayJS.invokeDeliveryDateAPIForPDP(resolvedcatalogEntryId,catalogEntryID);
					 }else{
						 CheckoutHelperJS.invokeDeliveryDateAPI("onLoad");
					 }

					 					 fnCloseZipcodeModal();
				 }
				 if(_bIsDebuggingEnabled){
					 console.debug('Debugging:: Exiting fnGetNearestStoresByZipCode().');
				 }

							}


	 			 			 function fnCloseZipcodeModal(){
				 if(_bIsDebuggingEnabled){
					 console.debug('Debugging:: Entering fnCloseZipcodeModal().');
				 }
				 try{
					 var modalRows = $('.row-set');
					 document.getElementById('sameday-popup-zipcode').value = '';
					 if($(modalRows[0]).is(':visible')){
							$(modalRows).each(function(){
								$(this).remove();
							});
						}

					 $('#sameday-zipcode-error').html('');

					 petcoCommonJS.hideModal('modal-zipcodeLocation');


					 					 				 }catch(err){
					 console.log('An error occured in fnCloseZipcodeModal(). '+err);
				 }
				 if(_bIsDebuggingEnabled){
					 console.debug('Exiting:: Entering fnCloseZipcodeModal().');
				 }
			 }

			 		 function _populate_Service_location(){
			 console.log("in _populate_Service_location");
			 if(typeof(window.pagetype) === 'undefined' || (typeof(window.pagetype) !== 'undefined' && !window.pagetype=='home')){
				 if(typeof(petcoLocation) != 'undefined'){
					 try{
						 setTimeout(function(){petcoLocation.populateCity();
						 console.log("in _populate_Service_location")
						 },500);
					 }catch(err){

						 					 }
				 }

										}
		 }

	 return{
	 	fnGetNearestLocations: fnGetNearestLocations,
	 	fnOpenStoreInfoModal:fnOpenStoreInfoModal,
	 	fnCloseStoreInfoModal:fnCloseStoreInfoModal,
	 	fnGetNearestStoresByZipCode:fnGetNearestStoresByZipCode,
	 	updateZipcodeForSameday:updateZipcodeForSameday,
	 	fnSelectStore:fnSelectStore,
	 	fnGetMoreStores:fnGetMoreStores,
	 	fnUpdateBopusHeader:fnUpdateBopusHeader,
	 	fnSetPhysicalStoreCookie:fnSetPhysicalStoreCookie,
	 	updateReactStoreChange:updateReactStoreChange,
	 	fnOpenZipCodefoModal:fnOpenZipCodefoModal,
	 	fnCloseZipcodeModal:fnCloseZipcodeModal
	 };

})();

